/* eslint-disable */
// Larinz Labz Dashboard (verbatim from original bundle) wrapped as a CRA module.
// Registers window.Dashboard for the admin dashboard route.

import React from 'react';

if (typeof window !== 'undefined') {
  window.React = window.React || React;
}

// Default no-op persistData; AdminDashboard.jsx overrides this with an API PUT.
if (typeof window !== 'undefined' && !window.persistData) {
  window.persistData = function(data) {
    window.dispatchEvent(new CustomEvent('ll-data-changed', { detail: data }));
  };
}

/* eslint-disable */
// LARINZ LABZ DASHBOARD — full admin panel.
//
// Mounts as an overlay above the marketing site. Toggle with the floating
// FAB or with the keyboard shortcut Cmd/Ctrl + K. Edits are immediately
// reflected in the site behind it via window.LL_DATA + persistData().
//
// Tabs: Overview · Hero · Services · Projects · Studio · Reels · Brands
//       · Custom Sections · Settings (logo / contact / about)

function Dashboard({ open, onClose, onLogout }) {
  const [tab, setTab] = React.useState('overview');
  const [data, setData] = React.useState(window.LL_DATA);

  // Listen for external changes so the panel reflects them.
  React.useEffect(() => {
    const handler = e => setData({ ...e.detail });
    window.addEventListener('ll-data-changed', handler);
    return () => window.removeEventListener('ll-data-changed', handler);
  }, []);

  // Apply a partial update and persist.
  const update = (patch) => {
    const next = typeof patch === 'function' ? patch(window.LL_DATA) : { ...window.LL_DATA, ...patch };
    window.LL_DATA = next;
    setData(next);
    persistData(next);
  };

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: '#0A0A0A',
      display: 'flex', flexDirection: 'column',
      fontFamily: 'Inter, sans-serif',
    }}>
      <DashHeader data={data} onClose={onClose} onLogout={onLogout} />
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        <DashSidebar tab={tab} onTab={setTab} />
        <div style={{ flex: 1, overflow: 'auto', background: '#F4F4F0' }}>
          <div style={{ padding: '32px 40px', maxWidth: 1200, margin: '0 auto' }}>
            {tab === 'overview'  && <TabOverview  data={data} onTab={setTab} />}
            {tab === 'theme'     && <TabTheme     data={data} update={update} />}
            {tab === 'icons'     && <TabIcons     data={data} update={update} />}
            {tab === 'hero'      && <TabHero      data={data} update={update} />}
            {tab === 'services'  && <TabServices  data={data} update={update} />}
            {tab === 'projects'  && <TabProjects  data={data} update={update} />}
            {tab === 'studio'    && <TabStudio    data={data} update={update} />}
            {tab === 'reels'     && <TabReels     data={data} update={update} />}
            {tab === 'brands'    && <TabBrands    data={data} update={update} />}
            {tab === 'sections'  && <TabSections  data={data} update={update} />}
            {tab === 'messages'  && <TabMessages />}
            {tab === 'settings'  && <TabSettings  data={data} update={update} />}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   CHROME
═══════════════════════════════════════════════════════════ */

function DashHeader({ data, onClose, onLogout }) {
  const fileRef = React.useRef();

  return (
    <header style={{
      background: '#0D0D0D', borderBottom: '1px solid rgba(255,255,255,.08)',
      padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      flexShrink: 0, gap: 16,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <img src={data.logo || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjgAAAEmCAYAAABvQeqAAAAMTGlDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU1cbPndkQggQiICMsJcgIiOAjBBWANlbVEISIIwYE4KKGymtYN0ighOtgihYrYAUF2pdFMW9iwMVpRZrcSv/CQG09B/P/z3Pufe97/nOe77vu+eOAwC9iy+V5qKaAORJ8mUxwf6spOQUFukZwIEmQIAFcOIL5FJOVFQ4gDZ8/ru9vgY9oV12UGr9s/+/mpZQJBcAgERBnC6UC/Ig/gkAvFUgleUDQJRC3nxWvlSJ10KsI4MBQlyjxJkq3KrE6Sp8cdAnLoYL8SMAyOp8viwTAI0+yLMKBJlQhw6zBU4SoVgCsR/EPnl5M4QQL4LYBvrAOelKfXb6VzqZf9NMH9Hk8zNHsCqXQSMHiOXSXP6c/7Mc/9vychXDc1jDpp4lC4lR5gzr9ihnRpgSq0P8VpIeEQmxNgAoLhYO+isxM0sREq/yR20Eci6sGWBCPEmeG8sb4mOE/IAwiA0hzpDkRoQP+RRliIOUPrB+aIU4nxcHsR7ENSJ5YOyQzzHZjJjhea9lyLicIf4pXzYYg1L/syInnqPSx7SzRLwhfcyxMCsuEWIqxAEF4oQIiDUgjpDnxIYN+aQWZnEjhn1kihhlLhYQy0SSYH+VPlaeIQuKGfLfnScfzh07liXmRQzhS/lZcSGqWmGPBPzB+GEuWJ9Iwokf1hHJk8KHcxGKAgJVueNkkSQ+VsXjetJ8/xjVWNxOmhs15I/7i3KDlbwZxHHygtjhsQX5cHGq9PESaX5UnCpOvDKbHxqligffB8IBFwQAFlDAlg5mgGwg7uht6oVXqp4gwAcykAlEwGGIGR6RONgjgcdYUAh+h0gE5CPj/Ad7RaAA8p9GsUpOPMKpjg4gY6hPqZIDHkOcB8JALrxWDCpJRiJIAI8gI/5HRHzYBDCHXNiU/f+eH2a/MBzIhA8xiuEZWfRhT2IgMYAYQgwi2uIGuA/uhYfDox9szjgb9xjO44s/4TGhk/CAcJXQRbg5XVwkGxXlZNAF9YOG6pP+dX1wK6jpivvj3lAdKuNM3AA44C5wHg7uC2d2hSx3KG5lVVijtP+WwVd3aMiP4kRBKWMofhSb0SM17DRcR1SUtf66PqpY00fqzR3pGT0/96vqC+E5bLQn9h12ADuNHcfOYq1YE2BhR7FmrB07rMQjK+7R4Iobni1mMJ4cqDN6zXy5s8pKyp3qnHqcPqr68kWz85UPI3eGdI5MnJmVz+LAL4aIxZMIHMexnJ2c3QBQfn9Ur7dX0YPfFYTZ/oVb8hsA3kcHBgZ+/sKFHgXgR3f4Sjj0hbNhw0+LGgBnDgkUsgIVhysPBPjmoMOnTx8YA3NgA/NxBm7AC/iBQBAKIkEcSAbTYPRZcJ3LwCwwDywGJaAMrATrQCXYAraDGrAX7AdNoBUcB7+A8+AiuApuw9XTDZ6DPvAafEAQhITQEAaij5gglog94oywER8kEAlHYpBkJA3JRCSIApmHLEHKkNVIJbINqUV+RA4hx5GzSCdyE7mP9CB/Iu9RDFVHdVAj1Aodj7JRDhqGxqFT0Ux0JlqIFqPL0Qq0Gt2DNqLH0fPoVbQLfY72YwBTw5iYKeaAsTEuFomlYBmYDFuAlWLlWDVWj7XA+3wZ68J6sXc4EWfgLNwBruAQPB4X4DPxBfgyvBKvwRvxk/hl/D7eh38m0AiGBHuCJ4FHSCJkEmYRSgjlhJ2Eg4RT8FnqJrwmEolMojXRHT6LycRs4lziMuImYgPxGLGT+JDYTyKR9En2JG9SJIlPyieVkDaQ9pCOki6RuklvyWpkE7IzOYicQpaQi8jl5N3kI+RL5CfkDxRNiiXFkxJJEVLmUFZQdlBaKBco3ZQPVC2qNdWbGkfNpi6mVlDrqaeod6iv1NTUzNQ81KLVxGqL1CrU9qmdUbuv9k5dW91Onaueqq5QX66+S/2Y+k31VzQazYrmR0uh5dOW02ppJ2j3aG81GBqOGjwNocZCjSqNRo1LGi/oFLolnUOfRi+kl9MP0C/QezUpmlaaXE2+5gLNKs1Dmtc1+7UYWhO0IrXytJZp7dY6q/VUm6RtpR2oLdQu1t6ufUL7IQNjmDO4DAFjCWMH4xSjW4eoY63D08nWKdPZq9Oh06erreuim6A7W7dK97BuFxNjWjF5zFzmCuZ+5jXm+zFGYzhjRGOWjqkfc2nMG72xen56Ir1SvQa9q3rv9Vn6gfo5+qv0m/TvGuAGdgbRBrMMNhucMugdqzPWa6xgbOnY/WNvGaKGdoYxhnMNtxu2G/YbGRsFG0mNNhidMOo1Zhr7GWcbrzU+YtxjwjDxMRGbrDU5avKMpcvisHJZFayTrD5TQ9MQU4XpNtMO0w9m1mbxZkVmDWZ3zanmbPMM87XmbeZ9FiYWky3mWdRZ3LKkWLItsyzXW562fGNlbZVo9a1Vk9VTaz1rnnWhdZ31HRuaja/NTJtqmyu2RFu2bY7tJtuLdqidq12WXZXdBXvU3s1ebL/JvnMcYZzHOMm46nHXHdQdOA4FDnUO9x2ZjuGORY5Nji/GW4xPGb9q/Onxn51cnXKddjjdnqA9IXRC0YSWCX862zkLnKucr0ykTQyauHBi88SXLvYuIpfNLjdcGa6TXb91bXP95ObuJnOrd+txt3BPc9/ofp2tw45iL2Of8SB4+Hss9Gj1eOfp5pnvud/zDy8Hrxyv3V5PJ1lPEk3aMemht5k333ubd5cPyyfNZ6tPl6+pL9+32veBn7mf0G+n3xOOLSebs4fzwt/JX+Z/0P8N15M7n3ssAAsIDigN6AjUDowPrAy8F2QWlBlUF9QX7Bo8N/hYCCEkLGRVyHWeEU/Aq+X1hbqHzg89GaYeFhtWGfYg3C5cFt4yGZ0cOnnN5DsRlhGSiKZIEMmLXBN5N8o6ambUz9HE6KjoqujHMRNi5sWcjmXETo/dHfs6zj9uRdzteJt4RXxbAj0hNaE24U1iQOLqxK6k8Unzk84nGySLk5tTSCkJKTtT+qcETlk3pTvVNbUk9dpU66mzp56dZjAtd9rh6fTp/OkH0ghpiWm70z7yI/nV/P50XvrG9D4BV7Be8FzoJ1wr7BF5i1aLnmR4Z6zOeJrpnbkmsyfLN6s8q1fMFVeKX2aHZG/JfpMTmbMrZyA3Mbchj5yXlndIoi3JkZycYTxj9oxOqb20RNo103Pmupl9sjDZTjkinypvzteBP/rtChvFN4r7BT4FVQVvZyXMOjBba7ZkdvscuzlL5zwpDCr8YS4+VzC3bZ7pvMXz7s/nzN+2AFmQvqBtofnC4oXdi4IX1SymLs5Z/GuRU9Hqor+WJC5pKTYqXlT88Jvgb+pKNEpkJde/9fp2y3f4d+LvOpZOXLph6edSYem5Mqey8rKPywTLzn0/4fuK7weWZyzvWOG2YvNK4krJymurfFfVrNZaXbj64ZrJaxrXstaWrv1r3fR1Z8tdyresp65XrO+qCK9o3mCxYeWGj5VZlVer/KsaNhpuXLrxzSbhpkub/TbXbzHaUrbl/Vbx1hvbgrc1VltVl28nbi/Y/nhHwo7TP7B/qN1psLNs56ddkl1dNTE1J2vda2t3G+5eUYfWKep69qTuubg3YG9zvUP9tgZmQ9k+sE+x79mPaT9e2x+2v+0A+0D9T5Y/bTzIOFjaiDTOaexrymrqak5u7jwUeqitxavl4M+OP+9qNW2tOqx7eMUR6pHiIwNHC4/2H5Me6z2eefxh2/S22yeSTlw5GX2y41TYqTO/BP1y4jTn9NEz3mdaz3qePXSOfa7pvNv5xnbX9oO/uv56sMOto/GC+4Xmix4XWzondR655Hvp+OWAy79c4V05fzXiaue1+Gs3rqde77ohvPH0Zu7Nl7cKbn24vegO4U7pXc275fcM71X/ZvtbQ5db1+H7AffbH8Q+uP1Q8PD5I/mjj93Fj2mPy5+YPKl96vy0tSeo5+KzKc+6n0uff+gt+V3r940vbF789IffH+19SX3dL2UvB/5c9kr/1a6/XP5q64/qv/c67/WHN6Vv9d/WvGO/O/0+8f2TD7M+kj5WfLL91PI57POdgbyBASlfxh/8FcCAcmuTAcCfuwCgJQPAgPtG6hTV/nDQENWedhCB/4RVe8hBg38u9fCfProX/t1cB2DfDgCsoD49FYAoGgBxHgCdOHGkDe/lBvedSiPCvcHWqE/peeng35hqT/pV3KPPQKnqAkaf/wU5yYMf/Qm62gAAAARjSUNQDA0AAW4D4+8AAACKZVhJZk1NACoAAAAIAAQBGgAFAAAAAQAAAD4BGwAFAAAAAQAAAEYBKAADAAAAAQACAACHaQAEAAAAAQAAAE4AAAAAAAAAkAAAAAEAAACQAAAAAQADkoYABwAAABIAAAB4oAIABAAAAAEAAAI4oAMABAAAAAEAAAEmAAAAAEFTQ0lJAAAAU2NyZWVuc2hvdFi/AcQAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHWaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA2LjAuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjI5NDwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj41Njg8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpVc2VyQ29tbWVudD5TY3JlZW5zaG90PC9leGlmOlVzZXJDb21tZW50PgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KBLN6EgAAABxpRE9UAAAAAgAAAAAAAACTAAAAKAAAAJMAAACTAAAkc5gQXB8AACQ/SURBVHgB7J0HWBRHG8dfiig2jLEbWzQKKHbFEiyANfbea+xgQ9TYe429a4yxK3ZEAXvsNfYWS0y+GBNNNJYYu9/s6ZkD7m5n9/aOveG/z8Oze7vvzLzzmwH+NzvzjstbdhAOEAABEAABEAABEBCIgAsEjkCtiaqAAAiAAAiAAAgYCEDgoCOAAAiAAAiAAAgIRwACR7gmRYVAAARAAARAAAQgcNAHQAAEQAAEQAAEhCMAgSNck6JCIAACIAACIAACEDjoAyAAAiAAAiAAAsIRgMARrklRIRAAARAAARAAAQgc9AEQAAEQAAEQAAHhCEDgCNekqBAIgAAIgAAIgAAEDvoACIAACIAACICAcAQgcIRrUlQIBEAABEAABEAAAgd9AARAAARAAARAQDgCEDjCNSkqBAIgAAIgAAIgAIGDPgACIAACIAACICAcAQgc4ZoUFQIBEAABEAABEIDAQR8AARAAARAAARAQjgAEjnBNigqBAAiAAAiAAAhA4KAPgAAIgAAIgAAICEcAAke4JkWFQAAEQAAEQAAEIHDQB0AABEAABEAABIQjAIEjXJOiQiAAAiAAAiAAAhA46AMgAAIgAAIgAALCEYDAEa5JUSEQAAEQAAEQAAEIHPQBEAABEAABEAAB4QhA4AjXpKgQCIAACIAACIAABA76AAiAAAiAAAiAgHAEIHCEa1JUCARAAARAAARAAAIHfQAEQAAEQAAEQEA4AhA4wjUpKgQCIAACIAACIACBgz4AAiAAAiAAAiAgHAEIHOGaFBUCARAAARAAARCAwEEfAAEQAAEQAAEQEI4ABI5wTYoKgQAIgAAIgAAIQOCgD4AACIAACIAACAhHAAJHuCZFhUAABEAABEAABCBw0AdAAARAAARAAASEIwCBI1yTokIgAAIgAAIgAAIQOOgDIAACIAACIAACwhGAwBGuSVEhEAABEAABEAABCBz0ARAAARAAARAAAeEIQOAI16SoEAiAAAiAAAiAAAQO+gAIgAAIgAAIgIBwBCBwhGtSVAgEQAAEQAAEQAACB30ABEAABEAABEBAOAIQOMI1KSoEAiAAAiAAAiAAgYM+AAIgAAIgAAIgIBwBCBzhmhQVAgEQAAEQAAEQgMBBHwABEAABEAABEBCOAASOcE2KCoEACIAACIAACEDgoA+AAAiAAAiAAAgIRwACR7gmRYVAAARAAARAAAQgcNAHQAAEQAAEQAAEhCMAgSNck6JCIAACIAACIAACEDjoAyAAAiAAAiAAAsIRgMARrklRIRAAARAAARAAAQgc9AEQAAEQAAEQAAHhCEDgCNekqBAIgAAIgAAIgAAEDvoACIAACIAACICAcAQgcIRrUlQIBEAABEAABEAAAgd9AARAAARAAARAQDgCEDjCNSkqBAIgAAIgAAIgAIGDPgACIAACIAACICAcAQgc4ZoUFQIBEAABEAABEIDAQR8AARAAARAAARAQjgAEjnBNigqBAAiAAAiAAAhA4KAPgAAIgAAIgAAICEcAAke4JkWFQAAEQAAEQAAEIHDQB0AABEAABEAABIQjAIEjXJOiQiAAAiAAAiAAAhA46AMgAAIgAAIgAALCEYDAEa5JUSEQAAEQAAEQAAEIHPQBEAABEAABEAAB4QhA4AjXpKgQCIAACIAACIAABA76AAiAAAiAAAiAgHAEIHCEa1JUCARAAARAAARAAAIHfQAEQAAEQAAEQEA4AhA4wjUpKgQCIAACIAACIACBgz4AAiAAAiAAAiAgHAEIHOGaFBUCARAAARAAARCAwEEfAAEQAAEQAAEQEI4ABI5wTYoKgQAIgAAIgAAIQOCgD4AACIAACIAACAhHAAJHuCZFhUAABEAABEAABCBw0AdAAARAAARAAASEIwCBI1yTokIgAAIgAAIgAAIQOOgDIAACIAACIAACwhGAwBGuSVEhEAABEAABEAABCBz0ARAAARAAARAAAeEIQOAI16SoEAiAAAiAAAiAAAQO+gAIgAAIgAAIgIBwBCBwhGtSVAgEQAAEQAAEQAACB30ABEAABEAABEBAOAIQOMI1KSoEAiAAAiAAAiAAgYM+AAIgAAIgAAIgIBwBCBzhmhQVAgEQAAEQAAEQgMBBHwABEAABEAABEBCOAASOcE2KCoEACIAACIAACEDgoA+AAAiAAAiAAAgIRwACR7gmRYVAAARAAARAAAQgcNAHkhyBh38/oNiYHfTXn3/SX/f/pOfPn1P69B9Thgwfk2/BglSiZCmnYPL40SNKkzatZr5KXB4+fESPWL5PHj+mZ8+e08sXL+jFS/bDzi9fvqQXz9n51UtDmalTp6Y00k9aL/JK50UfpU9P6T/6iDxTptTMJ2fP6MGD+/THnT/o3t27dP/+fQPHj1k/y5gpM/kV9nPK6v3z5Aldv3ad/vjjd8rE6pE1WzbKnCWzU9YFTotNAAJH5+27fu0q2hy5ifYfPhjH0yb1G1GzZi2pZOkyce7jg2UC077+mrZERtL1mz9ZNnr/5Ndf/2f4Z+Th4SFrmxgG3bt0oY1bIuMUnTFjBkrO/M2SOTM9Z4LE1YXozZu39JZZubu50eMnj+nGzVtx0jjiQ8kSxShrlqyUO3du8vX1pXLly7N/iFkcUbShjJ4hIbQ9JparvBXLllKZcuW4bC0ZtWjalHbu2WvpcZz7eXLnoi9q1qDhI0fFua/HD1PZ78/4iZMsula9ahXq1asX+5tU2qINzwPvgt48ZqptCuTLy343XMnFxYVcXdmZ/Uhn1/efDffYc1f2C2S4b3xuPBuevU9jvOcmpWc/0tlwz43cpHO8z1JZbux3UbJxY8/cXKVr9mO4fpe2fcdOquuGhHEJQODE5aGrTyePH6UGTetb9Wl7ZDQV8itq1QYPiXqHhtL6TZsVofApkJ927t6tKI2jjLt26kSbt0Y5qjjNy/kkezbKny8fFStRnIKDg6lY8RKal2HM0JECp2b1anTi1Glj0dzngr7eNHTwUApiIkGvR8aMmbhcW7rkW6pZqxaXrTkjewscc2Xq6V5hNoocEbFBTy45rS8QODpuuimTx9GMubOsejhv5jz6onY9qzZJ/eG1H3+kyoFBqjAM7B9OIT17qkprz0SdO3akyG3b7VmEQ/PO+2keNpJRkwYNGaJ5uY4UONWrVqVTp8+orsPiRQupTj19/j7zCpy6tb6gb5YsUc0gqQscCdzCufOpQsVKqhki4TsCEDg67wk582S16uGiuYuoWg3135asZi7IQ+l1ji1iQHpdpbfjy/btKSo6Rm9u2eyPNGo2YcJE8i+r3atXRwqcalWC6Ycz52zisHL5MqpavbpNedgjMa/Aqc2E6rdLv1Plwr49e6hraHdVaUVKNDAsnNp16ChSlRKlLhA4iYKdr1A5cSPl8u3CJRRcRX9/DPlqaH+r69euUaXKgTYV9NWAcOoRqq9RnA5t29L22B021UvPidetXUMBFStq4qIjBU6VoCA6c+68zX5vXL9Os/rb7Mz7DHgFzhc1qtN3y5apKjZy80bqP3iQqrQiJWreuAkNH6H/eVl6Zw6Bo+MW4hE4yxYvp0qBwTquReK61qNrV9oStc1mJ/Q2itO2dWuK3bnL5nrpNYM8uXLSoSNHDJMxbfXRkQInODCQzp6/YKvLhvQx27dRiVL6WdHHK3BqVqtGS1csV8Vg984d1KO3vr5MqKqIjYk6tGlL/Qd8ZWMuSA6Bo9M+8ObNG8qdN7usd6uWrqbPK1SStUuKBjdu3KCKGr3HHjSgP3VnE5X1crRu2ZJNgN6jF3fs4ke92rVpPpuTYuvhSIETWLkSnb9wyVaXP6Tf//0+8mErz/Rw8AocaTXV8pUrVbn8w6mT1KJNK1VpRUoU3qcvdfyys0hVSpS6QOAkCnb5Qn++dZMCKpeXNVy3aj2bryBvJ5uRgAY9urHRm622j94Y0ehpFKdV8+a0a+8+o2vCnnexb/SF/GyLF+NIgcMrApQ02KmTJyhnrlxKkmhuK33hypyZb2l/teAgWrF6tSofpFhB5QJsW6avqmCdJbpy8YrOPHJOdyBwdNpuPEvEJdc3r9tCxUvaFndCpwhscusmG73RehWCnkZxpFgre77fbxMjZ0jcvEljmjZzpk2uOrvAkSp/5fIl+jhDBps42JL42bNnlCNHTq4sqgYF0so1a7hszRlhFRXRnp27KVs2+RF8c/xw7z8CEDj/sdDVVWx0FHXqLh/wKWrzNipcpLiufNeDMyHdu7EAidrHidHLKE6zxo1p34G4wR8tcf+yQ3sWhfhdJOKXL1/RKxaRWIpK/PLVK3rNfozXr6TPr18bIhW/evWaXTNbdpbuG59J55cfnklp36WxVLat93N8kp1OnDxpUzYiCJzChQrS9uhoSp4ihU0s1CaWomZ/mjcfV/Jg9ppudUQEl605o8aN6tP5y5fNPUr0e/nz5mUBAskQJNCFXOj+33/TH/fuae4XRnC0QQqBow1HzXNZu3oFhQ8Kl803JmoH217AtiF82UKczOCnn36igIAKdvF68MCB1C2kh13yVpJpk0YNaf/Bw7JJ2rRqSZNYBFo9HJs2bKC9bBlwxIaNityJid5ORYsVU5TG1FgEgSPVp0SxohSzI3FWzknbmnj78M0FCqxUkdauW2faBEJfN2hQly5dvapZHSFuNENJEDjasdQ0p28WzaNR4+SXCe6O3Uuf5ffWtGxnzyy0e3faFLmVuxr5Wej2H6/f4LbXwyhOw/r12Sqjo7I+jxoxnDqzlWR6Orp17qyofWZMnUpNWzRXXQVRBI4EoEzpUrR1m3bzynih3vntDhspLsJlXrliAEWsTzqReJd9t4TGTZ7IxYbHCAKHhxKfDQQOHyeHW82fO5P90oyXLffA3kOUK/ensnZJxeDWT7fo84AARdVdwWJ2tGrThjvN4K/YKE6PxB3FacCi3R4+ekzW599/vyNrkxgGWdjeVLzHgPAw6hPWj9c8gZ1IAkeqXED5crRxs7JtRxJAUXjjl59/5t6EtmLA57R+o7JROoXu6Mr8Bdust3BxPvEX3/EMGVNT1uxpKGfuNJTtE0/yD0hLbx8HU0DZpvFN8VkFAQgcFdAckWTWjCk0ebr8q4UjB09Q9uyfOMIlpygjlAmPTfE2obTmeFjvXtSnXz+SJu3uPyT/yseYV2KP4tSrU4eOHj9hdMfiWa8CR8lWE21bt6SJk+V/FyxB0KvA8WI7wT9kc1vUHEGVK9KaCMe9Brpx/TqVKcu3uqnC5+Vpw6ZNaqrllGmOHj5E7TpZjzqcMpUHeXl5UvqPPSl7jtSUJ18qKlU+rdn6Zk4XQJ99wv+Fy2wmuGkgAIGj044wbcpEmjZ7uqx3J4+epkycyzdlM3NyA+lbZrnynyuqhVGoSCHiW7HgWrzHkEFfUVf2KiyxjjpsM8PjJ09ZLd7LKy1d1XBugNXCFD7czjYK7cA2DOU5pMBxakP/S/nrVeAUK1qYTtuwrYMt8WZ4uJvaXLl0mTuy8uflyrIvGVtMkwtz/fzlA/rr4Rl6/PQmPXtxjx4/++/V9vGDkliVdiAn8vBwIc+UbpTGy42yZPdQXH+/3P3IK3UBxemQIC4BCJy4PHTzadLEMTR7/hxZf87+cJE++ii9rF1SMOjJRm82Khi9kV59hPbq/QFNczaKc8BJRnFqsf1+Tv5gfdfqLFky05kzZz7UT28XvK+ppFcy69gEZbWHXgVO6ZLFafG3S8ivsLrXGxIPWze25GV6/uxZCgzm2+m8PNtHbHNkJG/WTmH36Ol1un1vN/312LYVfUoq+3mhRUrMYWuGAASOGSh6uDVh3Eiau2i+rCuXz/9IqVKnkbUT3eB/v/xCZcspC3hoHL0xstm7eze1btvO+FH2PJTtmdOlWzdZO3sYfFGjhuyu1Xly56IjR+UnItvDP548eQVOcGBlWrFqFU+WZm30KnCME4Zv3rxJ/v5lzPrOc7Nxg/o0d8ECHlPVNqfYUv3qNWpypS9Xxp8F2OSf5M+VaSIZvX7znG7cXkt3Hx5wuAfeObpRBq/iDi9XpAIhcHTamlO/Hk/T58yU9e76lVvkkTy5rJ3oBr1CQmjDZv5hcUvLvZs3aUIHDh/hxhVfJHEntNGwBnttc/rsOau5+Pp40569e63aJObDAgUK0MOHj2RdaFS/Hs2eN0/WzpKBXgVO+bL+bKTjnRC4dOEiVaxc2VIVZO+3bNaUps+aJWun1uAYW7FXi8374jmMwo3HVs820qjNuZvarY5SWtesHwVR3uzNlCaDvQkBCBwTGHq6nDWTTTKeJj+x8uebvxmCTunJd0f78uv//sc9AdLomyVhsmfXLmrTrr3RTPacWKM41aoEs00dL1r1z7tAftr3/fdWbRLzIe8ITk8Wd2jQkCGqXdWrwIm/GkrJKIk5GO3btrFbzKODBw5Q/QYNzRWb4J5/qZIUtX17gvvOdOPOX/vpxp3lieZyulR+VChPz0QrX5SCIXB02pIL5s2isZPGyXr3y0/6XAYs67iGBkpHb4YPHUKdunSx6IEUJfggR4wZYwaWxJLxuT3OVYKC6PxF65s65sqZg44dP26P4jXJk1fgzJszm+o35Pvnas4xvQqcShUCEswtOnzwINWt38BcNbjude30JY0eJ/93gyszEyNpEn7jpnyjCdLcom3RMSapnevy5m8R9Nv9nQ53OstHgeSV6jNKlzo/JXM3v8LK4U45eYEQODptwCWLF9DwMSNkvUvqAuf2r7fJv4yy+QtygmQ3ixbbtoP1ZZ+mDTN8yGDq5OBgekFsXsrFS1dM3UhwnSljBjp3/nyC+3q5wStwrv14ldKwJdVqD70KHEtLvaVRxKbNW6itLls11oOGDh+uOr25hLt37KRmbAd7nqNk8WIUHRvLY6o7m6u/fEP3HsnHl7LV8ZQe2SltynyULo0P+/Eld1dPW7NEejMEIHDMQNHDrVXLv6OBw76SdSWpC5zePUNZUDH+oGdjRo6gdh3lxUtTNorDEynY2EByoslop9WZRxykSZOarl27plWRmubTsV072hYj/0+wIJtHtNvGeUR6FTjWNqWMYdGKWyt4VRq/cfqH9aVwtq2IVkcse+XUinMCfmJuKaG2vm/fvqZLt+bQg3/s94VAeu0kTRpOl9qHUnh8rNZVpFNAAAJHASxHmq5fu4r6DgyTLTIpC5w7v/1GpUr7yzIyGvj6FKAdO3cZP1o972TfQNt3/NKqjelDR4/i8AgcyT+9BvrLyzYt/Oefp6YIzV5LG4WOsfGVi14Fjlwcmy0bN9GXVl6lmgVmclOaH9az939hEEweKb6MYsu+eX8firP4PrGcv2eKHbFDAim2zYmr/e2QM5EkarxS5aWM6cpA1NiFsPVMIXCs80m0p7t3sn+wndvJlp+UBU4fNnqzTsHozYRxYxVtydCkUSOu7RCMjeTIURxnFjhh7J/uyjVrjdisnr/ft5cKeNu215peBU6tGtVpCdsmxNqxbs0a6h6qfrLp2FEjqbMGoQyUiK2ihf1oJwu54AzH308u04VbUzV3NUu6ikzUlGbB+vJrnjcy5CcAgcPPyqGWly6ep+q1qsqWmVQFzp07d6hUqdKyfIwGfoV8KZrjlYjRXjrviImhDl/yRduV7Eewycu2fOOW8uA9eAVO/359qW8/+V3pecu1xW7NypW0lcVH2b2Pb2VXZTYJd3VEhC1FGtLqVeDwBulbsXSZYTsRtSC+njSR2rbnXxlorpwNrB269ggx9yjBvSJ+hWgXm5Ss9+PkmTX0zF1bIZY9fTXKkbkGubul0nv1k4R/EDg6bebHjx5SwSLy31yTqsDp06snW4HCv9/NFPZHvmkL5RM3G7PVO0eO8a9EctQoDq/AaVivLs2ZP9/hvfzIoUN0jsXpuXDhPF1m20Vc/fEavXz5UpEfEWtWU4VKlRSlMWesV4HToG4dWvDNN+ZcTnDv20WLaMCgwQnu896YPWOGTTuyr121mkJ69eIqrjD7MrF77z4u28QyWrS0H/mUeKhZ8Zm8ylLOzHXxGkozotpkBIGjDUe75JIzT1bZfJOiwPnj99+5dzaWAEpD5mrjcsRGR1PHTp1l28FoMHLYUOrYmd/emE7pmVfgSPnmzPGJQVy8evWKXjCR8ZKdk7m5k3syd7Yclf0kS0bu788fPrNnHu7JDM+SeXiQB7OR7DzYtYuLi2H+zL//PqWn//5L/0o/z57RM3b+ha1q0+KwNbifqQ96FThKIxDPmzOHho0YaVo1RdffsGjHdVnUYzXHymXLqXeY/JxAKe9CBX1p7759aoqxe5ojhw/TmNGj6Mq16+Tp6cH2i/KgFJ7J2NmdUrJrz5TJKFUqdxYdPhmlTsPO7KdClXRW/fLO0YNNHi5q1QYPE4cABE7icOcqFQLHPKa+7JtkxIaN5h+auTtj2lRqyFZFqT30OIqjROCorXdipSvoy1ZO7dEuArNeBU6zxo1o1ty5ijDPnDaNxbkZryiNqfGKZUupGtvmQ+mxdMkS6td/AHeye/fucts6ynDK5ElsS4uFNhfn4eFuEEaBlcrS5MnzmOBnu2vi0CUBCBxdNss7pyBwEjbOvbt3qVjxEgkfWLgjLVm1dV8caYlsx86WAwPGL3rk8GFs1Id/7k789DyfRRU4eXLlpBVsrk7efPl4MHDZ6FXgqN1eYfLEiSxi8RSuupsz2rAuQvGrP6WvyPQkcP7680/qw74UHTqmXXybMJZf99BQc3hxT0cEIHB01BjxXalfvyadOmN9x+ik9oqqL1uBE7Gef2fpObNmssiw6oblTdujUYMGdPT4CdNbVq/tPRdHVIHTs0d3GjR0qFW2Sh/qVeC0adWSprARGTXHuNGjadrMWWqSGtJEb4uikqX5J+kvZHuBDR7GHzxQLwJnNRPLQzQMeujn60ujGPvCRYqoZo+EjiMAgeM41opL6hXahTZFRVpNl5QEjtLRm9IlS9DGzfxBAK2BjmaB1zp16WrNJM6zUSOGsxVY/HF04iTm+CCqwJGqrnXsHr0KnA5s76iJX8vvN2epO4xgQnDO/AWWHsve38cCKBYsVFDWTjKYO3s2DR85istWMtKDwJHCEWyOiuL2Wc6wOXvNPWa8+teDcvnjufYEIHC0Z6pZjtOnTaKpM61/w0tKAiesT29au45/9Gbh/HlUs1YtzdqjIRsJOnbiJHd+9hzFEVngtGvTmiZMmsTNWc5QrwJHCmI4nr1usuUYzKIVL1z8reosTrC9ynLnyS2bftb06TRq7DhZO6NBYgqcg/v3s61WOhhd0eQ87evJVKee7SPBmjiDTLgJQOBwo3K8YfS2rdQlxPqKnKQicKT36EWKFuNuhLL+pRNsZMid2ILh9q1RioKmjWajOO3tNIojssCR8B89cpj9481joSWU3darwOnauRONHjtWWWXMWIf37UvfLV9h5gnfrUsXL1DGTJmsGk+b8jWNm8AvOhNL4EyeOIHmL+Jbem+1wu8fBlaowCYmLzCsIOSxh42+CEDg6Ks94nhz585v5F/O+oTapCJw+vXtQ2si1sfhY+3DksXfUJVq1ayZqHrWoH49On7iFHdae43iiC5wmjRsQDPZsmgtDr0KnJDuXRW99rHGojeb8MobHTp+PlIQzG3btrOVQSnjP/rwWQoWOHHylA+f5S4cLXCk0BFhTOgdYSNSWh2YSKwVycTLBwIn8dhzlSy3kiopCBylozcB5cpqEgHXXANtZ5F4O3frbu6R2XujR45ge/jIb+5pNrGVm6ILHKnqt279RClSpLBCge+RXgVO79AQNnF3GF8lOKx6sB3tlYRPMM2yRLEiFMN2DLd0TGD7gU2ZNt3S4wT3HSlwVi5fRsMUzA9K4Gy8G5hIHA+IE3+EwNF549WpXY3OXDhn0cukIHCUjt5IsT4qBQZaZGbrgwb12CjOycQdxVEicKSIua9fv37/84Zev3lNb968oTfGe8ZrdjY8e82eGa6l82u6eOmKrchUpe8Z0oMGDRmiKq1pIr0KnLA+vWigDdGJTetovO7coSNtYiJczeFfqqTFgJhjWXC86TNnc2frKIHTp2dPimRhHLQ6MJFYK5L6yAcCRx/tYNGL0aOG0KIli80+98lfgGJj95l9JsrNBw/uk58f/5LMSgGf04rVq+1afWln5a7de3CXMYaN4rTTeBRHicDRelUSd8XjGUpbNbx4/oLmz51Dk6danzxvTKqF744SOJIozJw5i9F12XP/fmEUPoA/eJ5shu8N2rVpQ9uiY3jN49hJo58bt2yJc0/6MIottZ41d16C+5Zu2FvgfM9WgHXQONYUJhJbak3nvQ+Bo/O2O3L4ADVt2cSsl4W8fWl7tLabxZktKBFvhof1pdVr13F7sHb1KiofEMBtr9awAdvj6fjJH7iTaz0XxxkFjhHWyRMnqFbtOsaPVs9Xr14hLy8vqzZyDx0lcF48f07ZP8kh586H54MG9qc+Yf0+fNbyolXz5hS7S93fhsBKFdlqxbi/c8OGDKZ5CxZxu2hPgSO9Llv0rfqVY/ErIU0knrdwAduuJFn8R/js5AQgcJygAS3NwylcsBBFRVl+b+4EVbPq4t8PHlAhv8JWbUwfSn+Yl61Qv5rENC+5662bt1C3kBA5sw/Px44aqenSVV6B48finOzcteuDH3q54PV/GosT05wFxLPlcJTAefr0KeXKlZvb1WGDB1Eoi9Vir6Mpi9uyh3Pn9vg+VK9ahZazIHnGQ+lydHsInNu//krh/frRsZP8oRqM/ls6YyKxJTJi3IfAcYJ27NSxDcXuSShkirFXN1si1Q1FO0G1SenozcYN66m0v7/DqlafzW05ceo0d3lajuLwCgRpufwmM68cuJ22kyGv/9J+TdNnqY/YK7nvKIHz+NEj+jQv/xYTo9iWHkpEspqmaMjmi+0/dFhNUqrzRU1a/N13hrQD+4fT4iVLufPRWuAsY36MHDOGu3w5Q0wkliMkxnMIHCdpx1q1qtK5i+fjeFuCxYXZtEm7CXZxMk/kDw8fPqSCbISK96gWHPThjzFvGlvtIlmU5O4hodzZjGMTNdu0b89tb82QVyBUCQqM803cWp6OfFYlOJjOX7goW2QhXx/atWePrJ01A0cJHGm+WP783tZcifNMmrjbma18svdRhwW7PHJM3fJpaVf3eQsXktJYO1oKnF5spDQqRrsvcphIbO8ep5/8IXD00xaynkRvi6RZc2bQhcuXDLalipWgDRu1C0Uu64ADDQawoWglcT2itkZS0WL8gQC1qkq9OnXo5A98ozi+3gVoh0avi3gFTkM2V2jO/PlaVVezfGqwGEWnz1peHWhakK0TjR0lcKRwBt4+vqauW72eNH6c3QJBxi+4ZvXqbLSRf86YafoWTZuQm5sbLV/FP3lfC4Gzh/2udNJYAGIisWnLin8NgeOkbSzNyylTsjRFrEu44sFJq/TBbWmo38eXb48cKVHNalVsClf/oWAVF1s2baIeoT25U44bM5ratGvHbW/JkFfgaL3tgSV/lN6vVbMmtzB0FoEjBZtTMmdsyuRJmvQFHvbSCq/qVatyi8r4eRb2K0jnzsuPuBnT2SpwFrDNPSdN4Q8saCzX0hkTiS2REfs+BI6Ttu/unbEUVEX7SL16wDEgnI3erF7L7UosG77m3TSQO1MFhvXq1Gb/rM9wpfD1YaM4O22f9MsrcHr3DNE81gpXRWWMqlerSmfOxn3laimJswic27dvU1EF24nMmDaVWrRqZanamt//58kTqs1eV52/+G4EWPMCTDK0ReCcYSOiDZs0NsnNtsuw3r0UvUq2rTSk1hMBCBw9tYaJL+fOniYXF1f2Q+zH5f21dHYhV9d3ZxdXV3J9Z/D+vivLQXr+333puWTHsjHcf3fNbNyke9IzKS9mL53ff3Y1lCs9e3f/Q57ss72PJ+yPsLe3D3cxtWvWMMwR4E5gB8PNGzZSSK9e3DmPHzuGWrdty20f3/DN27eULWu2+LfNfh4+dAh168Efs8dsJna4WSUoiPsf7bUfr1KatGlVe+GoV1S//PwzlShZitvPubNmUuNmzbjttTC8d/cu+SqY26a2TFsEjhSROUaDV7mf5spFzRjf3LlzU/LkySmFpyd5sh/pnNIzJaVKnYpSpvTE8nC1jewE6SBwdNhIf967SxUrV9ChZ8pdWh+xQdHrpoHh4SxQ3xrugvbt3UP5PvuM295ehnVr16JTp89yZV/Qx5tidyZcFceVmBlJAfNy5MjJZT596lRq1qI5l60jjXhHoCSfbly/xv4ZpVbtnqMEzs2bN8nfvwy3nwvmzqUGbJWYow+lQkyNf7YInLz5+FeiqfFNTRqf/J8ZhJC7u7th402PZMkM52Ts7M5+DJ892NnDw+QnOSV//1kSWB4e7HNyD0qegomt5J7vzu9FlyS8UrK9wOQ2PVXje1JO838AAAD//63S+VAAACZmSURBVO2dB3xVRfbHD0XW/7q6llVRV1B6DR0EUTqhBUIRCCH03juh914DgdBrEpoRQiD0joL0LqKr0kQFhXVFWgj/c19y4yPk5c1t7953328+y957Z86cM/OdCL/MvTOT4QknQrIUgZu//EwVK1ewVJvUNiZm3WeUL38Boep3//iD8ubLL2QrGQXWrUPhcyOE7Y00XB8TQ9179hIOMXHcWGresqWwvbPhvT//pPdz5HTOcnm/ctkyqlbD32W5WQVZs74lHPqnn24I26Zl2KNbN4rfui2tomfyIlcspw/KlXsmXyTj20uXqOyH5UVMHTaLFy6guoGBwvZ6Gn598SKV/+hjPV0+5evmzV+eehZ9OH70KDUOChI1t6VdqeLFaPXadbbsm6c7lQECx9PI3cf7mf9Cr1y1kntDL7BYH7Oe8uQVEy2hAwZQZPQq4V598flBypY9u7C90YZ169ShE6dOC4UpWCAfbdu+Q8g2tdH/fv+dcufJmzo7zect8ZuoWPESaZaZmWlHgaNUNCxfuoRq8c+MWen0yZNUtbox4letwNm8cSP16NPHLCSWiduwXj2aPG2aZdrjrQ2BwLHgyEm/sVaxjcDZwAInn1vKf/KsRB7Bf7QlZ40aBNLMWbPd+vWkwWfrPqUevXsLh5w4fhw1b9FC2F42vH37N8qfv6D8mO71xPFj9PY776RrY0ahHQXO+XPnqWIl8V9MoleuNH127fChQxRQt57uPwJqBc7SxYtp7IQJurfHGx1u37aNcuYUm6n1xv55os0QOJ6grDDGjR+v829WVRTWsqZ57PpYypXb/WzDoIEDaWVUtHAnjh87Sm9mzSps7ynDgDq16eSpM0LhChXIT1u3bxeydTa6+csvVNiviHOWy3utr3dcOtZY8FH58vTNt/8R8qK1D556RXX29Gmeea0m1CfJaM2qaLavKmxvlOG+PXuoUeMmurpXK3DmhofTtJkzdW2LtzqbMGaMz7+u0zp2EDhaCRpQ//r1a1Td3/y/+PToWlxsHOXImTtdV/fv3WMRlCddG+fCJp80omkzZjhnWeY+bsMG6tytu3B7JvEsTrDCWZwbP/4o/NpJqzgQ7ohCw0YN6tPBLw67rSW9ytu1e49bu/QMPCVwTp44wf/d1kivKU+VrY/5lMp/bNx3ME8Fc/OwfetWCg5RPpvoyq1agROzdi0NGDzYlVufym/fpg2FgoWmMYfA0YTPmMrXrl0l/xrivwka0wp9vMZt3EQ5cuRK19ng0IG0IlJ89ubs2dP0yiuvpuvTzMLOHTpQXPwWoSYUKsizONuUzeJcuXyFSpcpI+TfqgJHYrR+Y5zbPpQpVZJi49zbpefIUwLnGH8gW7NW7fSa8lRZXOwG1R80P+VIp4dNsbHUul17XbypFTgH9++nlvwPOxJRm5YtaMiw4UChgQAEjgZ4RlW9evUK1ahZ3Sj3HvW7KW4zvf++6/fI9+/fp1y50p/hcW5w86CmNHHKFOcsy90r7dPkCeOpWUiIcD++++47KlfuQyF7qwqc6JWR1Kd/f7d9qFq5En94Li5+03LoKYFz5PBhqh1QN60mpJm3dctmKlGyVJplZmVKMyidunbTHF6twJEC58yV/i9EmhvnJQ5GDRumeqWll3TR8GZC4BiOWHmAy5e/p1q1ayqvaMEa8Zu3UPbs77ts2ZDQUFoeGeWyPHXBpUtf09///vfU2ZZ7vnr1KpUtK7bcuG/vntS7bz9FfRD5SNevcEHavmOnIr+eNPavVo1Onz2XbsjW/FvshEmT0rVxV+gpgXPo88952Xd9d81JKd+1cwf5FRH7liqlkgduVkdF0bCRo+jOnTuqo2kROL179KCN8fGqY9uhYu6cORTP7Nqh33r3AQJHb6I6+PMlgRO5fDnvZTOHrl2/4ZbcyuXLqFIV7/r4OnRAf56BWO2yb3Vq1qB5Cxe6LHdVsJlf27Rt38FVsSM/JLgZTbHwUtObv9ykli1CXC6tr/BReVqzTvt+IJ4SONLrlfoNG6U7Js6F+/ftpfwFxPaIcq7niftLF7+mUSNH0PZduxWFa9OqJTVs1Ej4FWpazv/g/bCkn90z5y+kVWz7vKJ+hWnJkiX0z5dfsX1fje4gBI7RhFX6D2nehJK2YHzC1ycOL9L1rzxKzk/Ok8rYKsk2Kc+Rk5wvFV769luVrVFfbeuW7fTuu9ncOjh75ixJU/Y3bvxE0iqhu7xs/JWXX6ZXX3uVKlWsRLUCAtz6sKqBtG/N7FlhFL9lK/3A389kz/ZvKlWyJLVp0478imr7DV561bN37x76mjeZ+/qbpPEtUawoValSmfr0c/8KyArMli5aRKfPnKZjx47TG2+8Qe/x3kZVeTVSrQD99ohp2rixUFdX8ysaLen6tev0JS+9PnfurONn+X9//I/+4D//eOEf9OKLL1LWt7JSAV7iX4q/oXrv/fe0hPJI3R++/54+XbeWTp08Rdd4defv//2drl7/0RH732+/TWVKl6KsvJqxur8/leOVcWanxMRESkx8TImPn1DiE+k+6c/jx5znyP8rTy5LcJQl5T9JtpfLpHp/5SX5/Os5kR4/TuS/c5Pr8t+1Uj3p72C5flIZ/00s57Ptk8S/yiU7KUamzJnp5X/+kwoXLergaTZHu8SHwLHLSKIfIAACIAACIAACKQQgcFJQ4AYEQAAEQAAEQMAuBCBw7DKS6AcIgAAIgAAIgEAKAQicFBS4AQEQAAEQAAEQsAsBCBy7jCT6AQIgAAIgAAIgkEIAAicFBW5AAARAAARAAATsQgACxy4jiX6AAAiAAAiAAAikEIDASUGBGxAAARAAARAAAbsQgMCxy0iiHyAAAiAAAiAAAikEIHBSUOAGBEDACgSGLXxIY9pnsUJT0AYQAAEvJgCB48WDh6aDgN0ISOLmu+uJlOOdjM+IHLksauTzdus2+gMCIGAAAQgcA6DCJQiAgHoCspBxFjlp5amPgJogAAK+QAACxxdGGX0EAS8j4CxopKa7mtXxsm6huSAAAh4kAIHjQdgIBQJKCGyLj6fde3bT7d9u0+07d+ju3bv0Mp+wLp2yPmfePDry5ZdUmk+ltmuSRY7UP+fZHLv21wr9kk63vn//Pt3780+6d++e4156fvDgPt2/94AePHxAjx5I14f08MFDevSIr9L9o0dJV75/xPdSvuP6ULpP/pOQQOFz51qhm2iDjxCAwPGRgda7mz//eobefM2Pzn4TRY8S7tLjxw8dIZ7L/H+UOfPf6fVXCjrK9Y7rC/5C+/enqDVrhLvauUMHGjx0qLC9GYZvvf224rAl62+gl173c9T7/eYZOrY+ULEPvSsUKpCfcuXMRYGBgeRfs6be7lP8rVi2jB45hAMLBRYJDyTBkCIWZBGRQAnJ4iGBxcMj/uN4lq6PpfsE/u+Sr/x84eKlFN9m34TPCqO6zA8JBIwmAIFjNGEb+j/51UK68esJoZ4VzhVC72YtJ2QLI6IunTpRHM/cKE0N6talsPBwpdU8Zq9U4MjiRhI2UpKEjlVEjgzNv2pVWrZihfyoyzW4aRAd+OILXXxZ1UkRv0IUt2mzVZuHdtmIAASOjQbTE135/Y8rdPDUBEWhqn0wjZ7jWR2k9AmcOXWaatcNSN8ondKYdess+8pKicBxFjfyrE1aeemg8FiRX8GCtDEujv72vPaVXTd+/JHKfFDWY203M9DxY0fp9TfeMLMJiO0DBCBwfGCQ9ezizd/O09ELymYKiufrRFn/VUTPZtjSV/s2bWjrzp2q+1b5449peWSk6vpGVhQVOOkJGbls94IcRjZVse9yH5ShmM/WK66XusK+PXsopGWr1Nm2fJ46eRI1btrUln1Dp6xDAALHOmPhFS25e+9n2nd8pKK2Fsvbnt56vbiiOr5mfPzYMQps0EBzt6NXrqSPKlTQ7EdvB6ICR4orCRl55kbvdhjlr0fXLjRoiLbvoE6fPEUB9eoZ1URL+R3Qtw9169nTUm1CY+xHAALHfmNqeI/iD3ZWFKN8sUH00gvZFNXxNePWLVvSTv4NXmv6qFw5il69Wqsb3esrETi6B/eAw9deeZXOnD1DGTNmVB1NWo2UK1du1fW9qWK7Nq1o+MhR3tRktNULCUDgeOGgmd1kpQKn5odzKEMG9X/xm91fo+MfOXyYGjZurFuYJQsXUjV/f9386eHI7gJHYqTHLM4nDRvSl0eP6YHc0j4GDxxAnbp2tXQb0TjvJwCB4/1j6PEenPsmkq78/Llw3FrlI4RtfdGwVUgI7dq3T7euf1CqFK2LidHNnx6OfEHg5M+bh/ct2qsZV7Zs2TX7sLqDsBnTqT6LOSQQMJIABI6RdG3q+8S5tfTTHbHXKdnfqkgFczaxKQnt3fr8wAFqGhys3VEqDxG8ZLwOLx23SlIicAb07UuJjx/TY9507smTJ5SY+Jj/JPKeLtJzIpfxvaPMKY+fJZvExCf0JOWenx31uR7nJ0p1k8ucn+V7KZb0mujmrVv07XffqUJ3cP9+ypkrl6q6cqWhgwfRisho+dGW1x9++F7T6zxbQkGndCcAgaM7Uvs7XDR/Af34+x4qWfZlt519/YUqVKpYI7d2vmoQ0qwZ7T14UPfulyxWjNbHxuruV61DJQJHWi5tdrr8ww/0AX/PpDSNHj6c2vNeRlrT7du/0dbN8Q5RJ23W9zhZ8Emb9iWJPRaAnCeJP0cZiz7HfYIkDKU8SfwllUuiT76X8h2CMVkkSkLSUZ4sIiVxKIlHWQhKvhx5Uj0WiJIYlPJu3rzJQvA3Vd38kFedrVq7VlVdVAIBJQQgcJTQgq2DwJJFi2jchElP0XjhxefphRf+Ri/8Iwv948W/Of68+FIWqvphCH9f8slTtnhIIiAtC27OHxeLpvx58tBXl8R3pA2bNo0afGIN9qIC571s2egQf5NklRS/aRMNGDiQfr19W6hJQcx7eliYkK23GgXz8u4DXxxS3fzYDeupWHGsqlQNEBWFCUDgCKOCoUxgxdJlNGrsOPkx3euUSROoQSPM4KQFqZnjHwrxXWsjly9XJIiKFCpEm1TsipxWW7XmiQqcqpUq08ooa+3ls/7TGOrSo7sQggrly9Nqm85OnDl9muoEaHvtOWzIYGrfsaMQSxiBgFYCEDhaCfpg/Sjenn74qDFCPZ/KAqc+BM4zrHbzhn4teWM/0TR00CDq2LkzBQcF0f7PxT/wnjx+PAU1by4axjA7UYEjfXA9YdLTs4OGNUqB4w5t21Lcli1uaxTz86P4rVvd2nmbQQyLtt79+mtq9oJ5EVSjVi1NPlAZBJQQgMBRQgu2DgKro6JoyPCRQjSmTprIAgerJVLDasrLwj9X8Crm6pUrDhf79+6l4BYtUrtz+VwwXz7aun27y3JPFYgKnN49etCA0FBPNUs4zmE+H0pEqBfMn4927tot7NcbDKdNmUxhs+eobmr+fHkoPHwO5eZXrEgg4EkCEDiepG2TWGt5I7lBQ4YJ9Wba5IkUiOWgT7Hazr/ht+UTwEWTPHsj2zfnWZx9CmZxxowYQa14BsLMJCpwxowcSe0UsPFkn0oWL0HXf7qRbshCBQrQDg3HbaTr3ITCXvxq7rMNG1VH/qhcWYqy4MaTqjuEil5FAALHq4bLGo39bN2n1D90kFBjpvNvf/Ua1Bey9RWjxjyjdejIUeHuyrM3cgWlszhSvdQ+ZF+euooKHOnD6MYs4KyYqvHp4ecuXEi3aaVLlKBYPnzT29OD+/epBb8uPPTlEdVdaRhYj2bMmqW6PiqCgFYCEDhaCfpg/Vg+WLBP/wFCPZ8+lQVOfQgcGdaWzZupA39LI5pSz97I9ZTO4rjyI/sz+ioqcIYPGUKdLbrDbeVKFemrr9NfxebPImgZf6PmzenIl19So0+07azdrUsnftUo9kuQN7NC261NAALH2uNjydZtit1IPfv0FWobBM7TmBrybNaRY8efzkznydXMi7fN4ogKHD2OO0gHp6aiQgULul0u3q51KxozbrymOGZWXhUZRQMHD9bUhAnjxlIwz/4ggYDZBCBwzB4BL4y/ZdNmPgm4l1DLZ0ydQnXrBwrZ2t1oE2+817m72HJjicVQ/ti2Y5cuLrEoncUZyDsEm3WCs6jAkTY+nDx1qss+m1kg0ofpk6fwqjX9d6b2RL8njBtHEbyJp5YUHbmSyn/8sRYXqAsCuhGAwNENpe84kj6S7dxV7B/qmdOmUEAgBI7001G/Xj06dvKk8A+Kq9kb2YE3zeKIiAOpX5U++pii11jvNHRpef5ugfPCjh09Su+88448RF5z7dq5E8Vtdr8M3lWHivoVpoWLFtObWd90ZYJ8EPA4AQgcjyP3/oC7duykDp3EviOZOX0aBdTTtjmY9xMj2hDzGXXvLTbrJfXX3eyNzETpLE4vnkHq21/bfiZybCVXUYGT/d136TB/A2KlFLNundDMV64cOeiAAcduGMniv3duU+vWrenYcXHhnbo91SpXosXLlqXOxjMImE4AAsf0IfC+BuzdvYfathdb5hzGAqcOBA7VC6hDJ06fER5sd7M3sqMDPKvQTOH3DqK+5Rh6XEUFjhTLCmdRyX2eNXMmzQibRfcf3JezXF6b8jENM7zomAbpYNBmzbV9KxMc1NSSGzO6HCQU+BQBCByfGm59Oiv9xdiytdi+KrNmTKfadQP0CeylXqRdYHv16yfcetHZG9lhc/5uZZ+CmYMuHTvwPkZD5eoeuXpS4HzKvB/zoZTSwZQJfJikdJWepUMknfOlAygdZXx1HGjJB1VK9lL+LT5R/KuLF+ny1avCfFZFRlLFypWF7c00XL50KQ0bMVJTE/r37UPde/bU5AOVQcBIAhA4RtK1qW9pV9fgELFDImfNZIET4NsCJ6B2LTp19pzwT4PSGRZvmMVRInCEQVnIsEDevLSLD0/1hjR65AhatGSZpqaG8S8u9bGBpyaGqGw8AQgc4xnbLsKxI0eoSZDYSpHZYTOoVp06tmMg2qE10auoX+hAUXMawiunOqWzcsqVI6WzONJy5hGjRrtyp3u+3QVOKH/X1LN3b9256e2wY7t2tGX7Dk1uN8ZuoKLFimnygcog4AkCEDieoGyzGCePn6BGjZsI9Wp22EwWOLWFbO1oVKtGDTrrZvdb534rnb2R66qZxfnh++8pU6ZMsgtDr3YXOFb6biitgfzpxg3qyEdgnFTwHVhqP2VKlaRIPofub88/n7oIzyBgSQIQOJYcFms36uyZMxRYX+wAzXAWODV9VOBEr4ykgUPEN01TO3sj/7QoncVpEdyMxk2YKFc39GpngVOmZEnasFH9eU2Ggmfnu3bsoNZt22kKU6dmDZo7f74mH6gMAp4mAIHjaeI2iPcVz0jUCagn1JM5s8KoBn+D4ouphn91Ov/VReGuq529kQNIH38HNW8uPwpdL5w7Ry++9JKQrRYjOwscicvUiRMVnfKuhaWSugtZlGjdWbldm9Y0nA9BRQIBbyMAgeNtI2aB9n5z6RLVqCn22mnObBY4tXxP4KzgfUGGDB8uPFpaZ2/kQNJOwHsVrKgK4qXNk/mAS6OT3QWOHx/jsI1nSqyUhvHs4fKVUZqaNGLYUN4Sor0mH6gMAmYRgMAxi7wXx/3+u++oajV/oR7MDZ9F/jVrCtnayejdbNkUdUfr7I0cTM0sjvTR+JtZs8ouDLnaXeBI0PrxR8ZmbKKY1oC1bdWKdvB+VVrS4gXzqRp/Q4YEAt5KAALHW0fOxHZf471BKlQU2+8jggVOdR8TOMsWL6Zho0YJj9DggQN1PUFb6SxOIz5KY8asWcLtVWPoCwJH4nLh/Dl65ZVX1SDSpY704XhXXoV39vwF1f4K5M9Lc+dGUI6cOVX7QEUQsAIBCBwrjIKXtUFakfFhebED9SLmzKbqPvZboFmzN/KPkZpZHGkV1nvvvy+70P2qROBMHDuWMmTISBkyZqCMGTLwle/5mpHzMnKeXNaQX68Zmfbu3k0HDuynNes+pV9/+00oVACL+QUscM1IWzZvpo6dXR/OKtKmCuU/pJXR0SKmsAEByxOAwLH8EFmvgbdu3qIyH5QVati8OeE8zS32OkvIocWNFi1YQKP4H2jRpPfsjRxX6SxOXf4QfE7EPLm67ldRgZPluSx0+fIPusfX6rCGvz+dPntWyM2KJUs9/jM/NzycJvJJ5lrSJw3r07QZM7W4QF0QsBQBCBxLDYd3NObOnTtUokQpocbOnzuHqvJqIl9JZs/eyJzVzOJIp8TnL1BAdqHrVVTgvJ89O31x6JCusfVyVqZ0abpy7Zpbd54+ET10wACKXr3GbbvSM+jerQv1HyC+IWV6vlAGAlYhAIFjlZHwonbcvXuX/PyKCrV4fgQLnOq+IXDmz51LY3m5sGgyavZGjh/SLJhXVB2QH91ea/I4LVi0yK2dGgNRgVO+bFlaFxOjJoThdTau30Adu4q9AoqLjaWSpcR+CdDS8Ba8LcDe/eJjnFasyRPGU9NgsZ3J06qPPBCwKgEIHKuOjIXb9fDBA/5Nv5BQCxewwKniIwLHKrM38sComcWJXb+eipcoIbvQ7SoqcBrWq0fhERG6xdXbUU1+3XrqjPtXVXX4u7OFS5boHT7F38ULX1HPXj34QNBLKXlqblZHR1G58uXVVEUdELA8AQgcyw+R9RqYyKcy586dV6hhC+ZFUJVqVYVsvdlobvhsmqDgG4jB/Dqgc7euhndZ6SxO1YoVaemKFbq3S1TgtOCZhElTtH1LonvjnRyGh4XRuEmTnHJc3xp1fEPsZ+upe69ergMLlBQr4kdL+ETx1/71LwFrmICAdxKAwPHOcTO91Tlz5hZqw8L5EVS5qv0FjtVmb+TBUTOLs4ZX0ej9W72owOnWuRMNGSa+QaLcT09eRfuyNT6eihQVe5Ur2v6Z06fT9JlhouZp2lWvUpkWsbhBAgG7E4DAsfsIG9Q/UYGzaP48qlS1ikGtsIbbWTNn0hT+h0c0eWr2Rm5PCM+K7D0g/p1GBX5lEanzUmFRUeANp3KL9iWCVzYFNmggD4Pma9/evfj7pPWa/IQEB3ns/DFNDUVlENCBAASODhB90QUEzl+jbtXZG7mFB1ncBCn8iHQ5fz+i58ybqCjo1L4djRg1Wm66Ja/Zs79HDx89dNu2WTNm0CdNmri1EzFoxn4OHjosYurSJrR/P+rSvbvLchSAgN0IQODYbUQ91B9RgbN44XyqWFls12MPNV3XMDP5HKdp/F2GaBrES3q7dOsmaq6bndJZnHJlyvAGd+t0iy8qcIIaN+ZXMNbei0W0Lyv5PDKtKwhPnzxJAfUCNY9DOB96W5d3rEYCAV8iAIHjS6OtY1/FBc4CFjiVdIxsLVdWn72RaX3OszhKlwIv4NVMNWvXll1ouoqKgtq8+miRgauPNHUiubJoX748fJiyKTyTzLl969as4bOtBjhnqbrfHLeRChcpoqouKoGANxOAwPHm0TOx7aICZ+nihfQxr8yxY5o2eTLN5O8sRJNZszdy+6QVSnsUfItTukRxiuG9X/RIoqKgNC9Rj42L0yOkIT5GDh9G8xeJHcWgZRXVlMmTaHb4XE19KFumNEWtiqbMmZ/T5AeVQcBbCUDgeOvImdxuCBwib5m9kX9U1MzihPProno6fCgrKnDe4GXLp8+ckZtsuWvxYsXoxs8/C7VLrcDRYxl43Tq1KZw3nkQCAV8mAIHjy6Ovoe/iAmcRz+BU0BDJmlUnT5xAs/nEZdE0aEB//vbG/A88lc7iFPPzo42bNol206WdqMCRHKgVBi6D61DwxcGDNJ53/D1+8pSQN3/eGmGZyv2EsmXLLhTDlVHb1i1p0JChlCVLFlcmyAcBnyAAgeMTw6x/J0UFTmBAHXrjzTeeasCTJ0+een7mIZ3yNGs62adZLgVwUTB42NBnwotkeNvsjdwnNbM403hju8ZBQbILVVclAmcqH3cR3KKF4jgx/FH0A95l+8H9+3Tf+cr3Dx9y/oOH9FD68zD5D6+EevTokeNZujr+JEjXhKR7zktISKBfbt1S3JaBfftRr759FNdbE72K+oeGKq5ndIWC+fNRpkzSCe8ZKVPGTJSR7x1XxzPfZ5LyMnGedOK707OUJ9tK10yZKTPnjVNwpInRfYN/+xKAwLHv2BraM1GBY2gjdHD+n/98o9jLeD4tPIJPDRdNVpm9kdurdBanMB/AGc8HcWpJSgSOFOetrFnp0UMWG8mCQxIlCY8TtDTBo3U38pEXpXglmtLUumVL2rVnr9JqXme/besWww529ToYaLBhBCBwDENrb8d2EThrVkVRST4lWkny1tkbuY9qZnHGjxlDIfyPr9qkVOCojWOVempfs2l9PWWV/rtrx5hRI6ll69buzFAOApoIQOBowue7le0icEaPGM6vQ0KEB3LMqFG0YLHYKhrJ6aD+/O2NBTdXaxUSQrv27RPut2R49coVRfbOxr4kcJoHNaUp08R3tnbm5CsCp0unDhQ6eIhz13EPAroTgMDRHalvOLSLwOnDJzJ3VSBAvH32Rv7pPHb0KNVv2FB+FLqOHDqU2nboIGSb2siXBM5xZvv2O++kRiD07CsCp+knjWgyb5KJBAJGEoDAMZKujX3bReC0b9uaf5McLDRSI4cPp8W8O61osursjdz+9m3a0NadO+VHoavaWRxfETjt27Sm0WPHCbFMy8hXBE4rnjUdzd+yIYGAkQQgcIyka2PfdhE4A3ilS8cund2OVGJiImV/7z23ds4GasWAsw8j769fu04flCurKITaD6Z9QeB8WLYsfRoTo4hnauPqvLz84iXlH76n9mP15/783133nj2t3ky0z8sJQOB4+QCa1Xy7CJwJ48ZQ46ZN3WIcPmQILV250q2dbCCdiq3k1Zdcz9PXhfPn0+hxymYc1Ag3uwucKhUqUiTvGqw1teLl8bv3Kvs2SmtMM+ovnBdB/rVqmREaMX2IAASODw22nl21i8DZEr+J8uTN6xaNXb69Sauj7Xg1y7Zdu9IqeiavBs8wLFRxVpRdBU7BfPmoIX/L1Llr12dYqclYFRlJA33g49srVy6rwYM6IKCIAASOIlwwlgnYReAo2Qdn7OhRQucQbY2Pp4KFCsmovOI6sF8/il67Nt22du3UUfXKFz0ETqEC+XkTueTN5Bybx0mbykkbyfEmc8mbyzlvQpcps2SbvCmdvOEcbzTn2HjOcc3k2HTOYecoZ/vM0kZ0ko1cxs+OPH7mq7SZnXR96aWXqCgf2/Am79ejd2rWpAkdPHRYb7eW8VfErxDFbdpsmfagIfYlAIFj37E1tGfz5vA5Nxmk/zn+jzJm4Kv0xFfpj5QyZEy6PlPG2bwnKhs42SbfO6pmcJQ+XV8qT/Hv8J4SKymmI6DkNTk/6TkpdlJb5PpJoZNiV6lWTXKmKJ08cZz279tPt27dpF9//Y2yPPccvfav16h0qdJeP+2+f+9eOn/+PP33v3fo3r179Oqrr1HhwoWpMs/cIHmOwJXLlx2bbz9JlLbgfkKJ8m7dfJV3AndcpefkZkm28pNU5myXVN05T3Kb6KjpiJAcx3HvME7yKpkk+ZTqyoGebk9K2xwuHR6S/DraINeXCpPif1ShQrIjXEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIEABI4J0BESBEAABEAABEDAWAIQOMbyhXcQAAEQAAEQAAETCEDgmAAdIUEABEAABEAABIwlAIFjLF94BwEQAAEQAAEQMIHA/wO1aAQVKu2kwgAAAABJRU5ErkJggg=='} alt="" style={{
          height: 32, width: 'auto', filter: 'invert(1) hue-rotate(180deg) saturate(2)',
        }} />
        <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,.1)' }} />
        <div style={{ fontSize: 12, color: 'var(--ll-accent, #A5FF12)', fontWeight: 800, letterSpacing: 2, textTransform: 'uppercase' }}>Dashboard</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input ref={fileRef} type="file" accept="application/json" style={{ display: 'none' }}
          onChange={async (e) => {
            const f = e.target.files[0];
            if (!f) return;
            try {
              await importData(f);
              alert('✓ Imported. Reload the dashboard panel to see changes.');
            } catch (err) {
              alert('Import failed: ' + err.message);
            }
            e.target.value = '';
          }} />
        <DBBtn label="Import" onClick={() => fileRef.current.click()} />
        <DBBtn label="Export JSON" onClick={() => exportData()} primary />
        <DBBtn label="Reset" danger onClick={() => {
          if (confirm('Wipe ALL content and reset to defaults? This cannot be undone.')) resetData();
        }} />
        {onLogout && <DBBtn label="Sign Out" onClick={onLogout} />}
        <DBBtn label="✕  Close" onClick={onClose} />
      </div>
    </header>
  );
}

function DashSidebar({ tab, onTab }) {
  const groups = [
    { label: 'Overview', items: [['overview', '▦', 'Dashboard']] },
    { label: 'Brand', items: [
      ['theme',     '◆', 'Theme · Colors'],
      ['icons',     '✺', 'Icons'],
    ]},
    { label: 'Pages', items: [
      ['hero',      '✦', 'Hero'],
      ['services',  '◈', 'Services'],
      ['projects',  '▤', 'Projects'],
      ['studio',    '◐', 'Studio'],
      ['reels',     '▶', 'Reels'],
      ['brands',    '◉', 'Brands'],
    ]},
    { label: 'Custom', items: [['sections', '⊞', 'Custom Sections']] },
    { label: 'Inbox', items: [['messages', '✉', 'Messages']] },
    { label: 'Site', items: [['settings', '⚙', 'Settings · Logo · About']] },
  ];
  return (
    <aside style={{
      width: 240, background: '#0D0D0D', flexShrink: 0,
      borderRight: '1px solid rgba(255,255,255,.06)',
      overflow: 'auto',
    }}>
      {groups.map((g, gi) => (
        <div key={gi}>
          <div style={{
            fontSize: 9, color: 'rgba(255,255,255,.2)',
            letterSpacing: 2.5, textTransform: 'uppercase',
            padding: '18px 18px 6px', fontWeight: 700,
          }}>{g.label}</div>
          {g.items.map(([id, glyph, label]) => (
            <div key={id} onClick={() => onTab(id)} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 18px', fontSize: 13, fontWeight: 500,
              color: tab === id ? '#fff' : 'rgba(255,255,255,.45)',
              background: tab === id ? 'rgba(165,255,18,.06)' : 'transparent',
              borderLeft: `2px solid ${tab === id ? 'var(--ll-accent, #A5FF12)' : 'transparent'}`,
              cursor: 'pointer',
            }}>
              <span style={{ width: 14, textAlign: 'center' }}>{glyph}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      ))}
    </aside>
  );
}

/* ════════════════════════════════════════════════════════════
   PRIMITIVES — reusable form parts
═══════════════════════════════════════════════════════════ */

function DBBtn({ label, onClick, primary, danger, small, onLight }) {
  const styles = {
    fontFamily: 'Inter, sans-serif',
    fontSize: small ? 11 : 13,
    fontWeight: primary ? 800 : 600,
    padding: small ? '6px 12px' : '8px 16px',
    borderRadius: 6,
    cursor: 'pointer',
    border: `1px solid ${danger ? '#fcc' : (primary ? 'var(--ll-accent, #A5FF12)' : (onLight ? '#DADAD4' : 'rgba(255,255,255,.15)'))}`,
    background: danger ? '#fff0f4' : (primary ? 'var(--ll-accent, #A5FF12)' : (onLight ? '#fff' : 'transparent')),
    color: danger ? '#c00' : (primary ? '#111' : (onLight ? '#333' : '#fff')),
    transition: 'opacity .15s',
    whiteSpace: 'nowrap',
  };
  return <button onClick={onClick} style={styles} onMouseEnter={e => e.currentTarget.style.opacity = '.85'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>{label}</button>;
}

function Card({ title, children, actions }) {
  return (
    <div style={{
      background: '#fff', border: '1px solid #EAEAE6', borderRadius: 12,
      padding: 22, marginBottom: 14,
    }}>
      {title && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#111', letterSpacing: -0.2 }}>{title}</div>
          <div style={{ display: 'flex', gap: 8 }}>{actions}</div>
        </div>
      )}
      {children}
    </div>
  );
}

function Row({ children }) {
  return <div style={{ marginBottom: 14 }}>{children}</div>;
}

function Label({ children }) {
  return <label style={{ fontSize: 12, color: '#666', marginBottom: 5, fontWeight: 600, display: 'block' }}>{children}</label>;
}

function Input({ value, onChange, placeholder, type = 'text' }) {
  return (
    <input type={type} value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      style={{
        width: '100%', padding: '9px 12px', fontSize: 13,
        border: '1.5px solid #E0E0E0', borderRadius: 7, background: '#fff',
        color: '#111', outline: 'none', fontFamily: 'Inter',
        transition: 'border-color .2s',
      }}
      onFocus={e => e.target.style.borderColor = 'var(--ll-accent, #A5FF12)'}
      onBlur={e => e.target.style.borderColor = '#E0E0E0'} />
  );
}

function Textarea({ value, onChange, placeholder, rows = 3 }) {
  return (
    <textarea value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={rows}
      style={{
        width: '100%', padding: '9px 12px', fontSize: 13,
        border: '1.5px solid #E0E0E0', borderRadius: 7, background: '#fff',
        color: '#111', outline: 'none', resize: 'vertical', fontFamily: 'Inter',
        lineHeight: 1.6,
      }}
      onFocus={e => e.target.style.borderColor = 'var(--ll-accent, #A5FF12)'}
      onBlur={e => e.target.style.borderColor = '#E0E0E0'} />
  );
}

function Select({ value, onChange, options }) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)} style={{
      width: '100%', padding: '9px 12px', fontSize: 13,
      border: '1.5px solid #E0E0E0', borderRadius: 7, background: '#fff',
      color: '#111', outline: 'none', fontFamily: 'Inter',
    }}>
      {options.map(o => <option key={o.value || o} value={o.value || o}>{o.label || o}</option>)}
    </select>
  );
}

/* ════════════════════════════════════════════════════════════
   Image compression — keeps localStorage under quota.
   Resizes to max 1600px, re-encodes as JPEG q=0.85.
   Returns a data URL. Photos shrink from MB → hundreds of KB.
═══════════════════════════════════════════════════════════ */
async function compressImage(file, maxDim = 1600, quality = 0.85) {
  // SVG → keep as text data URL, no raster compression.
  if (file.type === 'image/svg+xml') {
    return new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
  }
  const dataUrl = await new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
  // PNG with transparency → keep as PNG (we'd lose alpha as JPEG).
  // GIF → keep as is (animation).
  if (file.type === 'image/gif') return dataUrl;
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = dataUrl;
  });
  let w = img.naturalWidth, h = img.naturalHeight;
  if (w <= maxDim && h <= maxDim && dataUrl.length < 500_000) {
    // Small enough already — no need to recompress.
    return dataUrl;
  }
  if (w > h && w > maxDim) { h = Math.round(h * maxDim / w); w = maxDim; }
  else if (h > maxDim) { w = Math.round(w * maxDim / h); h = maxDim; }
  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d');
  // White background prevents black bars if source had transparency we strip.
  if (file.type !== 'image/png') {
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);
  }
  ctx.drawImage(img, 0, 0, w, h);
  const outMime = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
  return canvas.toDataURL(outMime, quality);
}

/* Image upload — drag & drop OR click. Saves as data URL into the field. */
function ImageDrop({ value, onChange, label = 'Image', aspect = '16/9' }) {
  const ref = React.useRef();
  const [drag, setDrag] = React.useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    if (!file.type.startsWith('image/')) { alert('Drop an image file'); return; }
    try {
      const compressed = await compressImage(file);
      onChange(compressed);
    } catch (e) {
      alert('Image read failed: ' + e.message);
    }
  };

  return (
    <div>
      <Label>{label}</Label>
      <div
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); handleFile(e.dataTransfer.files[0]); }}
        onClick={() => ref.current.click()}
        style={{
          width: '100%', aspectRatio: aspect, position: 'relative',
          border: `1.5px dashed ${drag ? 'var(--ll-accent, #A5FF12)' : '#E0E0E0'}`,
          background: drag ? '#FAFFF0' : (value ? '#000' : '#FAFAF7'),
          borderRadius: 8, overflow: 'hidden', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#888', fontSize: 12, textAlign: 'center', padding: 14,
          transition: 'all .2s',
        }}>
        {value
          ? <img src={value} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <div>
              <div style={{ fontSize: 22, marginBottom: 6, color: 'var(--ll-accent, #A5FF12)' }}>↑</div>
              <div style={{ fontWeight: 700, color: '#111' }}>Drag image here</div>
              <div style={{ fontSize: 11, marginTop: 2 }}>or click to browse</div>
            </div>
        }
        {value && (
          <button onClick={(e) => { e.stopPropagation(); onChange(''); }} style={{
            position: 'absolute', top: 8, right: 8,
            background: 'rgba(0,0,0,.7)', color: '#fff', border: 'none',
            borderRadius: 4, padding: '4px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer',
          }}>Remove</button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files[0])} />

      {/* Paste an image URL instead of uploading — for unlimited images hosted on
          your own domain folder or a CDN (Cloudinary, etc.). No storage limit. */}
      <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
        <input
          defaultValue={value && /^https?:\/\//.test(value) ? value : ''}
          onBlur={e => { const v = e.target.value.trim(); if (v) onChange(v); }}
          onKeyDown={e => { if (e.key === 'Enter') { const v = e.target.value.trim(); if (v) onChange(v); } }}
          placeholder="…or paste an image URL (https://yourdomain.com/img/work-01.jpg)"
          style={{
            flex: 1, fontSize: 11, padding: '7px 10px',
            border: '1px solid #E8E8E4', borderRadius: 6,
            fontFamily: 'monospace', color: '#555', outline: 'none', background: '#fff',
          }} />
      </div>
    </div>
  );
}

/* List manager — add, edit, delete, reorder generic items.
   `renderEditor(item, idx, onChange)` returns the per-item editor. */
function ListEditor({ items = [], onChange, blank, renderEditor, renderPreview, addLabel = '+ Add item' }) {
  const update = (idx, patch) => {
    const next = [...items];
    next[idx] = typeof patch === 'function' ? patch(next[idx]) : { ...next[idx], ...patch };
    onChange(next);
  };
  const remove = (idx) => {
    if (!confirm('Delete this item?')) return;
    onChange(items.filter((_, i) => i !== idx));
  };
  const move = (idx, dir) => {
    const next = [...items];
    const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange(next);
  };
  const add = () => {
    onChange([...items, { id: Date.now(), ...(typeof blank === 'function' ? blank() : blank) }]);
  };
  return (
    <div>
      {items.map((it, i) => (
        <Card key={it.id || i}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18 }}>
            <div style={{ flex: 1 }}>
              {renderEditor(it, i, (patch) => update(i, patch))}
            </div>
            {renderPreview && (
              <div style={{ flexShrink: 0 }}>{renderPreview(it)}</div>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 14, paddingTop: 14, borderTop: '1px solid #F5F5F2' }}>
            <div style={{ display: 'flex', gap: 6 }}>
              <DBBtn label="↑" small onClick={() => move(i, -1)} />
              <DBBtn label="↓" small onClick={() => move(i,  1)} />
            </div>
            <DBBtn label="Delete" danger small onClick={() => remove(i)} />
          </div>
        </Card>
      ))}
      <button onClick={add} style={{
        width: '100%', padding: 14, background: '#fff',
        border: '1.5px dashed #A5FF12', borderRadius: 10,
        color: '#111', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
      }}>{addLabel}</button>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · OVERVIEW
═══════════════════════════════════════════════════════════ */

function TabOverview({ data, onTab }) {
  const stats = [
    { label: 'Projects',        n: (data.projects || []).length, tab: 'projects' },
    { label: 'Studio Items',    n: ((data.studio || {}).items || []).length, tab: 'studio' },
    { label: 'Reels',           n: (data.reels || []).length, tab: 'reels' },
    { label: 'Client Brands',   n: (data.brands || []).length, tab: 'brands' },
    { label: 'Custom Sections', n: (data.customSections || []).length, tab: 'sections' },
  ];
  return (
    <>
      <PageTitle title="Dashboard" sub="Manage every piece of your Larinz Labz site from one place." />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginBottom: 24 }}>
        {stats.map(s => (
          <div key={s.label} onClick={() => onTab(s.tab)} style={{
            background: '#fff', border: '1px solid #EAEAE6', borderRadius: 10,
            padding: 18, cursor: 'pointer', transition: 'border-color .2s, transform .2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--ll-accent, #A5FF12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#EAEAE6'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ fontSize: 11, color: '#888', letterSpacing: 1.5, textTransform: 'uppercase', fontWeight: 700, marginBottom: 6 }}>{s.label}</div>
            <div style={{ fontSize: 32, fontWeight: 900, color: '#111', letterSpacing: -1, lineHeight: 1 }}>{s.n}</div>
          </div>
        ))}
      </div>
      <Card title="Quick start">
        <ol style={{ paddingLeft: 18, fontSize: 13, lineHeight: 2, color: '#444' }}>
          <li>Set your <a onClick={() => onTab('settings')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>logo and contact info</a> in Settings.</li>
          <li>Edit your <a onClick={() => onTab('hero')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>Hero headline</a> and load your demo reel.</li>
          <li>Add your <a onClick={() => onTab('projects')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>portfolio projects</a> — each gets a cover photo, services, story.</li>
          <li>Upload your best shots into <a onClick={() => onTab('studio')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>Studio</a> — the photo &amp; film gallery.</li>
          <li>Drop in your <a onClick={() => onTab('reels')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>viral reels</a> and <a onClick={() => onTab('brands')} style={{ color: 'var(--ll-accent, #A5FF12)', fontWeight: 700, cursor: 'pointer' }}>client logos</a>.</li>
          <li>When you're happy, <strong>Export JSON</strong> from the top-right to back up everything.</li>
        </ol>
      </Card>
    </>
  );
}

function PageTitle({ title, sub }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <h1 style={{ fontSize: 28, fontWeight: 900, color: '#111', letterSpacing: -1.2, margin: 0 }}>{title}</h1>
      {sub && <p style={{ fontSize: 14, color: '#666', marginTop: 6, fontWeight: 400 }}>{sub}</p>}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · HERO
═══════════════════════════════════════════════════════════ */

function TabHero({ data, update }) {
  const h = data.hero || {};
  const set = (k, v) => update({ hero: { ...h, [k]: v } });
  return (
    <>
      <PageTitle title="Hero Section" sub="The first thing visitors see. Three lines of headline + your demo reel." />
      <Card title="Headline (3 lines)">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <div><Label>Line 1</Label><Input value={h.h1Top} onChange={v => set('h1Top', v)} placeholder="WE TURN" /></div>
          <div><Label>Line 2</Label><Input value={h.h1Mid} onChange={v => set('h1Mid', v)} placeholder="IDEAS INTO" /></div>
          <div><Label>Line 3 (green)</Label><Input value={h.h1End} onChange={v => set('h1End', v)} placeholder="IMPACT." /></div>
        </div>
      </Card>
      <Card title="Eyebrow & tagline">
        <Row><Label>Eyebrow label</Label><Input value={h.eyebrow} onChange={v => set('eyebrow', v)} placeholder="A Creative Studio" /></Row>
        <Row><Label>Bottom tagline</Label><Input value={h.tagline} onChange={v => set('tagline', v)} placeholder="A creative studio for brands that want to stand out and grow fast." /></Row>
        <Row><Label>CTA button label (arrow added automatically)</Label><Input value={h.ctaLabel} onChange={v => set('ctaLabel', v)} placeholder="View Our Work" /></Row>
      </Card>
      <Card title="Service tags (under headline)">
        <ChipList values={h.services || []} onChange={v => set('services', v)} placeholder="e.g. PHOTO" />
      </Card>
      <Card title="Side labels (right column, vertical)">
        <ChipList values={h.rightLabels || []} onChange={v => set('rightLabels', v)} placeholder="e.g. CONTENT." />
        <div style={{ fontSize: 11, color: '#888', marginTop: 8 }}>The last label is shown in green.</div>
      </Card>
      <Card title="Hero media — upload videos & photos (right column)">
        <div style={{ fontSize: 12, color: '#666', lineHeight: 1.6, marginBottom: 10 }}>
          Drop one or more <strong>videos</strong> or <strong>images</strong> below. They'll auto-cycle in the homepage hero. The first item shows on load. Drop a video to replace the intro reel — add more to build a rotating showreel.
        </div>
        <HeroMediaEditor
          value={h.mediaList || []}
          onChange={v => set('mediaList', v)} />
        <div style={{ height: 14 }} />
        <Row>
          <Label>Cycle speed (seconds per item)</Label>
          <Input type="number" value={h.mediaCycleSec || 6} onChange={v => set('mediaCycleSec', Math.max(2, Number(v) || 6))} placeholder="6" />
        </Row>
        <div style={{ borderTop: '1px solid #EAEAE6', marginTop: 18, paddingTop: 16 }}>
          <Label>Fallback embed URL (used only when no media uploaded above)</Label>
          <Input value={h.reelEmbed} onChange={v => set('reelEmbed', v)} placeholder="https://player.cloudinary.com/embed/..." />
          <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>Cloudinary, Vimeo or YouTube embed URL — leave blank if you uploaded files above.</div>
        </div>
        <div style={{ height: 14 }} />
        <Row><Label>EST. label (bottom-left corner)</Label><Input value={h.est} onChange={v => set('est', v)} placeholder="EST. 2024" /></Row>
      </Card>
    </>
  );
}

/* Small editable tag-pill list */
function ChipList({ values, onChange, placeholder }) {
  const [draft, setDraft] = React.useState('');
  const add = () => {
    const v = draft.trim();
    if (!v) return;
    onChange([...values, v]);
    setDraft('');
  };
  return (
    <div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
        {values.map((v, i) => (
          <span key={i} style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: '#FAFFF0', border: '1px solid #A5FF12',
            color: '#111', fontSize: 11, fontWeight: 700,
            padding: '4px 12px', borderRadius: 999,
            letterSpacing: 0.5, textTransform: 'uppercase',
          }}>
            {v}
            <button onClick={() => onChange(values.filter((_, j) => j !== i))} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#888', fontSize: 14, padding: 0, lineHeight: 1,
            }}>×</button>
          </span>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => e.key === 'Enter' && add()} placeholder={placeholder} style={{
          flex: 1, padding: '9px 12px', fontSize: 13,
          border: '1.5px solid #E0E0E0', borderRadius: 7,
          fontFamily: 'Inter', outline: 'none',
        }} />
        <DBBtn label="Add" onClick={add} primary />
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · SERVICES (CAPTURE / CREATE / CONNECT)
═══════════════════════════════════════════════════════════ */

function TabServices({ data, update }) {
  const list = data.services || [];
  return (
    <>
      <PageTitle title="Services" sub="Each service shows on the homepage as a card. Clicking opens a popup with the full description and deliverables." />
      <ListEditor
        items={list}
        onChange={v => update({ services: v })}
        blank={{ icon: '✦', name: 'NEW SERVICE', sub: 'SUBTITLE · GOES · HERE', short: 'One-line pitch.', full: 'Full description shown in the popup when the card is clicked.', deliverables: [] }}
        addLabel="+ Add service"
        renderEditor={(s, i, set) => (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 12 }}>
              <Row><Label>Icon (emoji)</Label><Input value={s.icon} onChange={v => set({ icon: v })} placeholder="📷" /></Row>
              <Row><Label>Name (uppercase, ends with green period)</Label><Input value={s.name} onChange={v => set({ name: v })} /></Row>
            </div>
            <Row><Label>Subtitle</Label><Input value={s.sub} onChange={v => set({ sub: v })} placeholder="PHOTOGRAPHY · VIDEOGRAPHY" /></Row>
            <Row><Label>Short pitch (card preview)</Label><Input value={s.short} onChange={v => set({ short: v })} placeholder="We capture more than moments." /></Row>
            <Row><Label>Full description (shown in popup)</Label><Textarea value={s.full} onChange={v => set({ full: v })} rows={3} /></Row>
            <Row>
              <Label>Deliverables (popup chips) — Enter to add</Label>
              <ChipList values={s.deliverables || []} onChange={v => set({ deliverables: v })} placeholder="e.g. Product Photography" />
            </Row>
          </>
        )} />
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · PROJECTS — Portfolio CRUD
═══════════════════════════════════════════════════════════ */

function TabProjects({ data, update }) {
  const list = data.projects || [];
  return (
    <>
      <PageTitle title="Projects" sub="Each project appears on the Work page and gets a full case-study detail view with branding, content, advertising and interior-design sections." />
      <ListEditor
        items={list}
        onChange={v => update({ projects: v })}
        blank={() => ({ name: 'New Project', tagline: '', type: 'Branding', cover: '', services: [], palette: [], gallery: [], story: '', branding: { strategy: '', deliverables: [] }, content: { strategy: '', platforms: [], volume: '', reels: [] }, advertising: { strategy: '', statsLabel: 'LIFETIME RESULTS', stats: [] }, interiorDesign: { strategy: '', images: [] } })}
        addLabel="+ Add project"
        renderEditor={(p, i, set) => (
          <>
            {/* CORE */}
            <Section title="Project basics">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Row><Label>Name</Label><Input value={p.name} onChange={v => set({ name: v })} /></Row>
                <Row><Label>Tagline</Label><Input value={p.tagline} onChange={v => set({ tagline: v })} placeholder="One-line headline" /></Row>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                <Row><Label>Categories (the chip below the cover)</Label><Input value={p.type} onChange={v => set({ type: v })} placeholder="Branding · Content · Advertising" /></Row>
                <Row><Label>Industry</Label><Input value={p.industry || ''} onChange={v => set({ industry: v })} placeholder="Food & Beverage" /></Row>
                <Row><Label>Year</Label><Input value={p.year || ''} onChange={v => set({ year: v })} placeholder="2024" /></Row>
              </div>
              <ImageDrop value={p.cover} onChange={v => set({ cover: v })} label="Cover image (16:9)" aspect="16/9" />
              <div style={{ marginTop: 14 }}>
                <Label>Project story (long-form, shown under cover)</Label>
                <Textarea value={p.story || ''} onChange={v => set({ story: v })} rows={4} placeholder="The brand background, the brief, what we built…" />
              </div>
            </Section>

            {/* BRANDING */}
            <DeptSection title="Branding section" subtitle="Renders when any field is filled.">
              <Row><Label>Brand Strategy (body text)</Label><Textarea value={(p.branding||{}).strategy || ''} onChange={v => set({ branding: { ...(p.branding||{}), strategy: v } })} rows={3} placeholder="A full identity system rooted in…" /></Row>
              <Row>
                <Label>Deliverables (chips)</Label>
                <ChipList values={(p.branding||{}).deliverables || []} onChange={v => set({ branding: { ...(p.branding||{}), deliverables: v } })} placeholder="e.g. Logo Design" />
              </Row>
              <Row>
                <Label>Brand palette</Label>
                <PaletteEditor value={p.palette || []} onChange={v => set({ palette: v })} />
              </Row>
              <Row>
                <Label>Brand-guidelines gallery (renders as "BRAND GUIDELINES" section at the end)</Label>
                <GalleryEditor value={p.gallery || []} onChange={v => set({ gallery: v })} />
              </Row>
            </DeptSection>

            {/* CONTENT */}
            <DeptSection title="Content Creation section" subtitle="Strategy + platforms + featured reels.">
              <Row><Label>Content Strategy (body)</Label><Textarea value={(p.content||{}).strategy || ''} onChange={v => set({ content: { ...(p.content||{}), strategy: v } })} rows={3} placeholder="We produce ongoing social content for…" /></Row>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Row>
                  <Label>Platforms</Label>
                  <ChipList values={(p.content||{}).platforms || []} onChange={v => set({ content: { ...(p.content||{}), platforms: v } })} placeholder="Facebook" />
                </Row>
                <Row><Label>Content Volume</Label><Input value={(p.content||{}).volume || ''} onChange={v => set({ content: { ...(p.content||{}), volume: v } })} placeholder="Weekly Reels" /></Row>
              </div>
              <Row>
                <Label>Featured Reels (drop poster images + IG link)</Label>
                <ReelsEditor value={(p.content||{}).reels || []} onChange={v => set({ content: { ...(p.content||{}), reels: v } })} />
              </Row>
            </DeptSection>

            {/* ADVERTISING */}
            <DeptSection title="Advertising section" subtitle="Campaign strategy + numeric stats grid.">
              <Row><Label>Campaign Strategy (body)</Label><Textarea value={(p.advertising||{}).strategy || ''} onChange={v => set({ advertising: { ...(p.advertising||{}), strategy: v } })} rows={3} /></Row>
              <Row><Label>Stats grid label</Label><Input value={(p.advertising||{}).statsLabel || ''} onChange={v => set({ advertising: { ...(p.advertising||{}), statsLabel: v } })} placeholder="META ADS — LIFETIME RESULTS" /></Row>
              <Row>
                <Label>Stats (n + label)</Label>
                <StatsEditor value={(p.advertising||{}).stats || []} onChange={v => set({ advertising: { ...(p.advertising||{}), stats: v } })} />
              </Row>
            </DeptSection>

            {/* INTERIOR */}
            <DeptSection title="Interior Design section" subtitle="Concept + interior images.">
              <Row><Label>Design Concept (body)</Label><Textarea value={(p.interiorDesign||{}).strategy || ''} onChange={v => set({ interiorDesign: { ...(p.interiorDesign||{}), strategy: v } })} rows={3} /></Row>
              <Row>
                <Label>Interior images</Label>
                <GalleryEditor value={(p.interiorDesign||{}).images || []} onChange={v => set({ interiorDesign: { ...(p.interiorDesign||{}), images: v } })} />
              </Row>
            </DeptSection>

            {/* SERVICES TAGS */}
            <Section title="Services tags (shown in meta strip)">
              <ChipList values={p.services || []} onChange={v => set({ services: v })} placeholder="e.g. Logo Design" />
            </Section>
          </>
        )}
        renderPreview={p => (
          <div style={{ width: 160 }}>
            <div style={{ width: 160, height: 100, borderRadius: 8, overflow: 'hidden', background: '#EAEAE6' }}>
              {p.cover && <img src={p.cover} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
            </div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 6, fontWeight: 700, letterSpacing: .3, textTransform: 'uppercase' }}>{p.type}</div>
          </div>
        )} />
    </>
  );
}

/* Inline section divider used within the project editor. */
function Section({ title, children }) {
  return (
    <div style={{ borderTop: '1px solid #EAEAE6', paddingTop: 18, marginTop: 8, marginBottom: 18 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: 'var(--ll-accent, #A5FF12)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14 }}>{title}</div>
      {children}
    </div>
  );
}

function DeptSection({ title, subtitle, children }) {
  const [open, setOpen] = React.useState(true);
  return (
    <div style={{ borderTop: '1px solid #EAEAE6', paddingTop: 18, marginTop: 18, marginBottom: 18 }}>
      <div onClick={() => setOpen(o => !o)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <span style={{ fontSize: 14, color: '#888' }}>{open ? '▾' : '▸'}</span>
        <div>
          <div style={{ fontSize: 13, fontWeight: 800, color: '#111', letterSpacing: -0.3 }}>{title}</div>
          {subtitle && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{subtitle}</div>}
        </div>
      </div>
      {open && children}
    </div>
  );
}

/* Hero media editor — accepts video AND image drops, URL paste, and lets you reorder + remove. */
function HeroMediaEditor({ value, onChange }) {
  const ref = React.useRef();
  const [urlDraft, setUrlDraft] = React.useState('');

  const detectType = (url) => {
    const u = (url || '').toLowerCase();
    if (/\.(mp4|mov|webm|m4v|ogv)(\?|#|$)/.test(u)) return 'video';
    if (/\.(jpe?g|png|gif|webp|avif|svg)(\?|#|$)/.test(u)) return 'image';
    if (/youtube\.com|youtu\.be|vimeo\.com|cloudinary\.com|player\.|embed/.test(u)) return 'embed';
    return 'embed';
  };

  const normalizeEmbed = (url) => {
    let m;
    if ((m = url.match(/youtu\.be\/([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&mute=1&loop=1&playlist=${m[1]}&controls=0&showinfo=0&modestbranding=1`;
    if ((m = url.match(/youtube\.com\/watch\?v=([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&mute=1&loop=1&playlist=${m[1]}&controls=0&showinfo=0&modestbranding=1`;
    if ((m = url.match(/vimeo\.com\/(\d+)/))) return `https://player.vimeo.com/video/${m[1]}?autoplay=1&loop=1&muted=1&background=1`;
    return url;
  };

  const addUrl = () => {
    const url = urlDraft.trim();
    if (!url) return;
    const type = detectType(url);
    const src = type === 'embed' ? normalizeEmbed(url) : url;
    onChange([...value, { id: Date.now() + Math.random(), type, src }]);
    setUrlDraft('');
  };

  const onFiles = async (files) => {
    const list = Array.from(files).filter(f =>
      f.type.startsWith('image/') || f.type.startsWith('video/'));
    const items = await Promise.all(list.map(async f => {
      const isVideo = f.type.startsWith('video/');
      const src = isVideo
        ? await new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(f); })
        : await compressImage(f);
      return { id: Date.now() + Math.random(), type: isVideo ? 'video' : 'image', src };
    }));
    onChange([...value, ...items]);
  };
  const move = (idx, dir) => {
    const next = [...value]; const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange(next);
  };
  return (
    <>
      {/* URL paste row */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <input
          value={urlDraft}
          onChange={e => setUrlDraft(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && addUrl()}
          placeholder="Paste any URL — direct .mp4, YouTube, Vimeo, Cloudinary, or image link"
          style={{
            flex: 1, padding: '11px 14px', fontSize: 13,
            border: '1.5px solid #E0E0E0', borderRadius: 8,
            fontFamily: 'Inter', outline: 'none', background: '#fff',
          }} />
        <DBBtn label="+ Add URL" onClick={addUrl} primary />
      </div>
      <div style={{ fontSize: 11, color: '#888', marginBottom: 10 }}>
        Examples: <code style={{ background: '#F4F4F0', padding: '1px 4px', borderRadius: 3 }}>https://yourcdn.com/reel.mp4</code> &middot; <code style={{ background: '#F4F4F0', padding: '1px 4px', borderRadius: 3 }}>https://youtu.be/abc123</code> &middot; <code style={{ background: '#F4F4F0', padding: '1px 4px', borderRadius: 3 }}>https://vimeo.com/12345</code>
      </div>

      <div
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); onFiles(e.dataTransfer.files); }}
        onClick={() => ref.current.click()}
        style={{
          border: '1.5px dashed #A5FF12', borderRadius: 8,
          padding: 22, textAlign: 'center', background: '#FAFFF0',
          cursor: 'pointer', fontSize: 13, color: '#111',
          fontWeight: 600,
        }}>
        ↑  Or drop video / image files here (or click to pick) — multiple OK
      </div>
      <input ref={ref} type="file" accept="image/*,video/*" multiple style={{ display: 'none' }}
        onChange={e => { onFiles(e.target.files); e.target.value = ''; }} />
      {value.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginTop: 14 }}>
          {value.map((it, i) => (
            <div key={it.id || i} style={{ background: '#fff', border: '1px solid #EAEAE6', borderRadius: 8, padding: 8 }}>
              <div style={{ aspectRatio: '9/16', borderRadius: 6, overflow: 'hidden', background: '#000', marginBottom: 8, position: 'relative' }}>
                {it.type === 'video'
                  ? <video src={it.src} muted style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : it.type === 'embed'
                  ? <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#A5FF12', fontSize: 28 }}>▶</div>
                  : <img src={it.src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                }
                <span style={{
                  position: 'absolute', top: 6, left: 6,
                  background: it.type === 'video' ? 'var(--ll-accent, #A5FF12)' : (it.type === 'embed' ? '#6B5BFF' : 'rgba(0,0,0,.7)'),
                  color: it.type === 'video' ? '#111' : '#fff',
                  fontSize: 9, fontWeight: 800, padding: '2px 8px', borderRadius: 3,
                  letterSpacing: 1, textTransform: 'uppercase',
                }}>{it.type}</span>
              </div>
              {it.type === 'embed' && (
                <div style={{ fontSize: 10, color: '#666', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 6 }} title={it.src}>{it.src}</div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 4 }}>
                <DBBtn label="↑" small onClick={() => move(i, -1)} />
                <DBBtn label="↓" small onClick={() => move(i,  1)} />
                <DBBtn label="×" small danger onClick={() => onChange(value.filter((_, j) => j !== i))} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
function ReelsEditor({ value, onChange }) {
  const ref = React.useRef();
  const onFiles = async (files) => {
    const list = Array.from(files).filter(f => f.type.startsWith('image/'));
    const imgs = await Promise.all(list.map(f => compressImage(f, 1200, 0.85)));
    const items = imgs.map(img => ({ id: Date.now() + Math.random(), img, url: '', label: '' }));
    onChange([...value, ...items]);
  };
  const setItem = (idx, patch) => {
    const next = [...value]; next[idx] = { ...next[idx], ...patch }; onChange(next);
  };
  return (
    <div>
      <div
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); onFiles(e.dataTransfer.files); }}
        onClick={() => ref.current.click()}
        style={{ border: '1.5px dashed #E0E0E0', borderRadius: 8, padding: 18, textAlign: 'center', background: '#FAFAF7', cursor: 'pointer', fontSize: 12, color: '#666', marginBottom: 10 }}>
        + Drop reel posters here
      </div>
      <input ref={ref} type="file" accept="image/*" multiple style={{ display: 'none' }}
        onChange={e => { onFiles(e.target.files); e.target.value = ''; }} />
      {value.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
          {value.map((it, i) => (
            <div key={it.id || i} style={{ background: '#fff', border: '1px solid #EAEAE6', borderRadius: 8, padding: 8 }}>
              <div style={{ aspectRatio: '9/16', borderRadius: 6, overflow: 'hidden', background: '#000', marginBottom: 8 }}>
                <img src={it.img} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <Input value={it.label || ''} onChange={v => setItem(i, { label: v })} placeholder="Caption" />
              <div style={{ height: 6 }} />
              <Input value={it.url || ''} onChange={v => setItem(i, { url: v })} placeholder="Instagram URL" />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
                <DBBtn label="Remove" small danger onClick={() => onChange(value.filter((_, j) => j !== i))} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* Stats editor — array of {n, l}. */
function StatsEditor({ value, onChange }) {
  const set = (i, patch) => { const next = [...value]; next[i] = { ...next[i], ...patch }; onChange(next); };
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 8 }}>
        {value.map((s, i) => (
          <div key={i} style={{ background: '#fff', border: '1px solid #EAEAE6', borderRadius: 8, padding: 10 }}>
            <Input value={s.n || ''} onChange={v => set(i, { n: v })} placeholder="4.65M" />
            <div style={{ height: 6 }} />
            <Input value={s.l || ''} onChange={v => set(i, { l: v })} placeholder="Total Impressions" />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
              <DBBtn label="×" small danger onClick={() => onChange(value.filter((_, j) => j !== i))} />
            </div>
          </div>
        ))}
      </div>
      <DBBtn label="+ Add stat" small onClick={() => onChange([...value, { n: '', l: '' }])} />
    </div>
  );
}

function PaletteEditor({ value, onChange }) {
  const set = (i, patch) => {
    const next = [...value];
    next[i] = { ...next[i], ...patch };
    onChange(next);
  };
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const move = (i, dir) => {
    const next = [...value]; const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...value, { name: 'New Color', hex: '#' + Math.floor(Math.random()*0xffffff).toString(16).padStart(6,'0').toUpperCase() }]);

  return (
    <div>
      {value.length === 0 && (
        <div style={{ padding: 24, textAlign: 'center', background: '#FAFAF7', border: '1.5px dashed #E0E0E0', borderRadius: 10, color: '#888', fontSize: 13, marginBottom: 12 }}>
          No colors yet — click "+ Add color" below to start your brand palette.
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 10, marginBottom: 12 }}>
        {value.map((c, i) => (
          <div key={i} style={{ background: '#fff', border: '1.5px solid #EAEAE6', borderRadius: 10, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {/* Big swatch (click to open native picker) */}
            <label style={{ position: 'relative', display: 'block', height: 80, background: c.hex || '#111', cursor: 'pointer' }}>
              <input type="color" value={c.hex || '#111111'} onChange={e => set(i, { hex: e.target.value })} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }} />
              <span style={{ position: 'absolute', top: 6, right: 6, fontSize: 9, fontWeight: 800, padding: '3px 7px', borderRadius: 4, background: 'rgba(0,0,0,.5)', color: '#fff', letterSpacing: 1 }}>EDIT</span>
            </label>
            {/* Name + hex */}
            <div style={{ padding: 10 }}>
              <input value={c.name || ''} onChange={e => set(i, { name: e.target.value })} placeholder="Color name" style={{ width: '100%', border: 'none', fontSize: 13, fontWeight: 700, fontFamily: 'Inter', outline: 'none', padding: '2px 0', color: '#111' }} />
              <input value={c.hex || ''} onChange={e => set(i, { hex: e.target.value })} placeholder="#hex" style={{ width: '100%', border: 'none', fontFamily: 'monospace', fontSize: 11, color: '#888', outline: 'none', padding: '2px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, paddingTop: 8, borderTop: '1px solid #F5F5F2' }}>
                <div style={{ display: 'flex', gap: 4 }}>
                  <DBBtn label="↑" small onClick={() => move(i, -1)} />
                  <DBBtn label="↓" small onClick={() => move(i,  1)} />
                </div>
                <DBBtn label="× Delete" small danger onClick={() => remove(i)} />
              </div>
            </div>
          </div>
        ))}
      </div>
      <button onClick={add} style={{
        width: '100%', padding: 14, background: '#fff',
        border: '1.5px dashed #A5FF12', borderRadius: 10,
        color: '#111', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
      }}>+ Add color</button>
    </div>
  );
}

function GalleryEditor({ value, onChange }) {
  const ref = React.useRef();
  const onFiles = async (files) => {
    const list = Array.from(files).filter(f => f.type.startsWith('image/'));
    const urls = await Promise.all(list.map(f => compressImage(f)));
    onChange([...value, ...urls]);
  };
  const addUrls = (text) => {
    const urls = text.split(/[\n,\s]+/).map(s => s.trim()).filter(s => /^https?:\/\//.test(s));
    if (urls.length) onChange([...value, ...urls]);
  };
  return (
    <>
      <div
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); onFiles(e.dataTransfer.files); }}
        onClick={() => ref.current.click()}
        style={{
          border: '1.5px dashed #E0E0E0', borderRadius: 8,
          padding: 18, textAlign: 'center', background: '#FAFAF7',
          cursor: 'pointer', fontSize: 12, color: '#666',
        }}>
        Drop images here, or click to add — multiple files OK
      </div>
      <input ref={ref} type="file" accept="image/*" multiple style={{ display: 'none' }}
        onChange={e => { onFiles(e.target.files); e.target.value = ''; }} />

      {/* Bulk URL paste — for unlimited images hosted on your domain / a CDN. */}
      <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
        <input
          placeholder="…or paste image URLs (one per line / comma-separated) and press Enter"
          onKeyDown={e => { if (e.key === 'Enter') { addUrls(e.target.value); e.target.value = ''; } }}
          onBlur={e => { if (e.target.value.trim()) { addUrls(e.target.value); e.target.value = ''; } }}
          style={{
            flex: 1, fontSize: 11, padding: '8px 10px',
            border: '1px solid #E8E8E4', borderRadius: 6,
            fontFamily: 'monospace', color: '#555', outline: 'none', background: '#fff',
          }} />
      </div>
      {value.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginTop: 12 }}>
          {value.map((src, i) => (
            <div key={i} style={{ position: 'relative', aspectRatio: '1', borderRadius: 6, overflow: 'hidden', background: '#000' }}>
              <img src={src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <button onClick={() => onChange(value.filter((_, j) => j !== i))} style={{
                position: 'absolute', top: 4, right: 4,
                background: 'rgba(0,0,0,.7)', color: '#fff', border: 'none',
                width: 22, height: 22, borderRadius: '50%', cursor: 'pointer', fontSize: 12,
              }}>×</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · STUDIO — Photo + Video gallery
═══════════════════════════════════════════════════════════ */

function TabStudio({ data, update }) {
  const s = data.studio || { items: [] };
  const setStudio = (patch) => update({ studio: { ...s, ...patch } });
  return (
    <>
      <PageTitle title="Studio" sub="The visual portfolio. Mix of photos and films with a category filter." />
      <Card title="Page header">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <Row><Label>Eyebrow</Label><Input value={s.eyebrow} onChange={v => setStudio({ eyebrow: v })} /></Row>
          <Row><Label>Headline (ends with green period)</Label><Input value={s.h1} onChange={v => setStudio({ h1: v })} placeholder="STUDIO." /></Row>
        </div>
        <Row><Label>Intro paragraph</Label><Textarea value={s.intro} onChange={v => setStudio({ intro: v })} rows={2} /></Row>
      </Card>
      <ListEditor
        items={s.items || []}
        onChange={v => setStudio({ items: v })}
        blank={{ type: 'photo', src: '', title: '', category: 'PHOTOGRAPHY' }}
        addLabel="+ Add studio item (photo or video)"
        renderEditor={(it, i, set) => (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <Row>
                <Label>Type</Label>
                <Select value={it.type || 'photo'} onChange={v => set({ type: v })} options={[
                  { value: 'photo', label: 'Photo' },
                  { value: 'video', label: 'Video / Reel' },
                ]} />
              </Row>
              <Row>
                <Label>Category</Label>
                <Input value={it.category} onChange={v => set({ category: v })} placeholder="PHOTOGRAPHY" />
              </Row>
              <Row><Label>Title</Label><Input value={it.title} onChange={v => set({ title: v })} placeholder="Caption" /></Row>
            </div>
            {it.type === 'video' && (
              <>
                <Row>
                  <Label>How should this video open?</Label>
                  <Select value={it.playType || 'link'} onChange={v => set({ playType: v })} options={[
                    { value: 'link',   label: 'Open the link in a new tab (Instagram, etc.)' },
                    { value: 'inline', label: 'Play inside the site (popup player)' },
                  ]} />
                </Row>
                {it.playType === 'inline'
                  ? <>
                      <Row><Label>Video URL to play (hosted .mp4, YouTube, or Vimeo)</Label><Input value={it.videoUrl} onChange={v => set({ videoUrl: v })} placeholder="https://…/reel.mp4  or  https://youtu.be/…" /></Row>
                      <div style={{ fontSize: 11, color: '#888', marginTop: -4, marginBottom: 8 }}>Instagram reels can't play inside other sites — for inline playback use a hosted .mp4 / YouTube / Vimeo. Instagram links should use "Open the link" above.</div>
                    </>
                  : <Row><Label>Link (Instagram reel, YouTube, etc.)</Label><Input value={it.href} onChange={v => set({ href: v })} placeholder="https://instagram.com/reel/…" /></Row>
                }
              </>
            )}
            <ImageDrop value={it.src} onChange={v => set({ src: v })} label={it.type === 'video' ? 'Poster / thumbnail' : 'Photo'} aspect={it.type === 'video' ? '9/16' : '4/5'} />
          </>
        )}
        renderPreview={(it) => (
          <div style={{ width: 90, height: 110, borderRadius: 6, overflow: 'hidden', background: '#EAEAE6' }}>
            {it.src && <img src={it.src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </div>
        )} />
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · REELS — Home-page reel grid (no view counts now)
═══════════════════════════════════════════════════════════ */

function TabReels({ data, update }) {
  return (
    <>
      <PageTitle title="Reels" sub="The 'MOMENTS THAT BREAK THE INTERNET' grid on the Home page. View-count numbers are intentionally hidden." />
      <ListEditor
        items={data.reels || []}
        onChange={v => update({ reels: v })}
        blank={{ handle: '', title: '', brand: '', img: '', url: '' }}
        addLabel="+ Add reel"
        renderEditor={(r, i, set) => (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Row><Label>Handle (@…)</Label><Input value={r.handle} onChange={v => set({ handle: v })} placeholder="@brandname" /></Row>
              <Row><Label>Brand name</Label><Input value={r.brand} onChange={v => set({ brand: v })} placeholder="Brand Name" /></Row>
            </div>
            <Row><Label>Caption / title</Label><Input value={r.title} onChange={v => set({ title: v })} placeholder="A short caption" /></Row>
            <Row>
              <Label>How should this reel open?</Label>
              <Select value={r.playType || 'link'} onChange={v => set({ playType: v })} options={[
                { value: 'link',   label: 'Open the link in a new tab (Instagram, etc.)' },
                { value: 'inline', label: 'Play inside the site (popup player)' },
              ]} />
            </Row>
            <Row><Label>{r.playType === 'inline' ? 'Video URL to play (hosted .mp4, YouTube, or Vimeo)' : 'Link URL (Instagram, etc.)'}</Label><Input value={r.url} onChange={v => set({ url: v })} placeholder={r.playType === 'inline' ? 'https://…/reel.mp4  or  https://youtu.be/…' : 'https://www.instagram.com/reel/…'} /></Row>
            {r.playType === 'inline' && <div style={{ fontSize: 11, color: '#888', marginTop: -4, marginBottom: 8 }}>Instagram can't play inside other sites — for inline playback use a hosted .mp4 / YouTube / Vimeo.</div>}
            <ImageDrop value={r.img} onChange={v => set({ img: v })} label="Reel poster (9:16)" aspect="9/16" />
          </>
        )}
        renderPreview={(r) => (
          <div style={{ width: 80, aspectRatio: '9/16', borderRadius: 6, overflow: 'hidden', background: '#111' }}>
            {r.img && <img src={r.img} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </div>
        )} />
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · BRANDS — Client logos
═══════════════════════════════════════════════════════════ */

function TabBrands({ data, update }) {
  return (
    <>
      <PageTitle title="Client Brands" sub="The 'BRANDS WE'VE TRANSFORMED' grid on the Home page. Upload the client logo or use initials." />
      <ListEditor
        items={data.brands || []}
        onChange={v => update({ brands: v })}
        blank={{ name: '', loc: '', initials: '', color: '#111111', result: '', logo: '' }}
        addLabel="+ Add client"
        renderEditor={(b, i, set) => (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Row><Label>Brand name</Label><Input value={b.name} onChange={v => set({ name: v })} /></Row>
              <Row><Label>Location</Label><Input value={b.loc} onChange={v => set({ loc: v })} placeholder="Riyadh, KSA" /></Row>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Row><Label>Initials (fallback if no logo)</Label><Input value={b.initials} onChange={v => set({ initials: v })} placeholder="NE" /></Row>
              <Row><Label>Avatar color</Label>
                <input type="color" value={b.color || '#111111'} onChange={e => set({ color: e.target.value })} style={{ width: '100%', height: 36, border: '1.5px solid #E0E0E0', borderRadius: 7, background: 'transparent', cursor: 'pointer' }} />
              </Row>
            </div>
            <Row><Label>Result badge</Label><Input value={b.result} onChange={v => set({ result: v })} placeholder="1M+ Views in 30 Days" /></Row>
            <ImageDrop value={b.logo} onChange={v => set({ logo: v })} label="Client logo (square recommended)" aspect="1/1" />
          </>
        )}
        renderPreview={(b) => (
          <div style={{ width: 70, height: 70, borderRadius: '50%', background: b.color || '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 18, overflow: 'hidden' }}>
            {b.logo
              ? <img src={b.logo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : (b.initials || '?')}
          </div>
        )} />
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · CUSTOM SECTIONS — full add/remove/reorder
═══════════════════════════════════════════════════════════ */

function TabSections({ data, update }) {
  return (
    <>
      <PageTitle title="Custom Sections" sub="Build your own sections — title, layout and a grid of images. They appear on the Home page below the brands grid." />
      <ListEditor
        items={data.customSections || []}
        onChange={v => update({ customSections: v })}
        blank={{ title: 'NEW SECTION', eyebrow: 'Custom', layout: 'grid3', items: [] }}
        addLabel="+ Add custom section"
        renderEditor={(s, i, set) => (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <Row><Label>Eyebrow</Label><Input value={s.eyebrow} onChange={v => set({ eyebrow: v })} /></Row>
              <Row><Label>Section title</Label><Input value={s.title} onChange={v => set({ title: v })} /></Row>
              <Row>
                <Label>Layout</Label>
                <Select value={s.layout || 'grid3'} onChange={v => set({ layout: v })} options={[
                  { value: 'grid2', label: '2 per row' },
                  { value: 'grid3', label: '3 per row' },
                  { value: 'grid4', label: '4 per row' },
                  { value: 'wide',  label: 'Full-width' },
                  { value: 'stack', label: 'Stacked list' },
                ]} />
              </Row>
            </div>
            <SectionItemsEditor value={s.items || []} onChange={v => set({ items: v })} />
          </>
        )}
        renderPreview={(s) => (
          <div style={{ width: 90, padding: 10, background: '#fff', border: '1px solid #EAEAE6', borderRadius: 8, fontSize: 11 }}>
            <div style={{ fontWeight: 700, marginBottom: 2 }}>{s.title || '—'}</div>
            <div style={{ color: '#888' }}>{(s.items || []).length} items</div>
          </div>
        )} />
    </>
  );
}

function SectionItemsEditor({ value, onChange }) {
  const ref = React.useRef();
  const onFiles = async (files) => {
    const list = Array.from(files).filter(f => f.type.startsWith('image/'));
    const srcs = await Promise.all(list.map(f => compressImage(f)));
    const items = srcs.map(src => ({ id: Date.now() + Math.random(), src, title: '', subtitle: '' }));
    onChange([...value, ...items]);
  };
  const setItem = (idx, patch) => {
    const next = [...value];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  return (
    <div>
      <Label>Images in this section</Label>
      <div
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); onFiles(e.dataTransfer.files); }}
        onClick={() => ref.current.click()}
        style={{
          border: '1.5px dashed #E0E0E0', borderRadius: 8,
          padding: 18, textAlign: 'center', background: '#FAFAF7',
          cursor: 'pointer', fontSize: 12, color: '#666', marginBottom: 10,
        }}>
        + Drop images here, or click to add
      </div>
      <input ref={ref} type="file" accept="image/*" multiple style={{ display: 'none' }}
        onChange={e => { onFiles(e.target.files); e.target.value = ''; }} />
      {value.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
          {value.map((it, i) => (
            <div key={it.id || i} style={{ background: '#fff', border: '1px solid #EAEAE6', borderRadius: 8, padding: 10 }}>
              <div style={{ aspectRatio: '4/3', borderRadius: 6, overflow: 'hidden', background: '#000', marginBottom: 8 }}>
                <img src={it.src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <Input value={it.title || ''} onChange={v => setItem(i, { title: v })} placeholder="Title" />
              <div style={{ height: 6 }} />
              <Input value={it.subtitle || ''} onChange={v => setItem(i, { subtitle: v })} placeholder="Subtitle" />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                <DBBtn label="Remove" small danger onClick={() => onChange(value.filter((_, j) => j !== i))} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · SETTINGS — logo, contact, about, stats, values
═══════════════════════════════════════════════════════════ */

function TabSettings({ data, update }) {
  const a = data.about || {};
  const c = data.contact || {};
  const setAbout = (patch) => update({ about: { ...a, ...patch } });
  const setContact = (patch) => update({ contact: { ...c, ...patch } });
  return (
    <>
      <PageTitle title="Settings" sub="Logo, contact info, about page, stats." />

      <Card title="Brand">
        <Row><Label>Brand name</Label><Input value={data.brandName} onChange={v => update({ brandName: v })} /></Row>
        <Row><Label>Bottom-of-footer tagline</Label><Input value={data.tagline} onChange={v => update({ tagline: v })} /></Row>
        <ImageDrop value={data.logo} onChange={v => update({ logo: v })} label="Primary logo (PNG / SVG)" aspect="3/1" />
        <div style={{ fontSize: 11, color: '#888', marginTop: 8 }}>This logo appears in the nav, hero, footer, and dashboard.</div>
      </Card>

      <Card title="Monogram — the small mark in the hero corner (currently 'LL')">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div>
            <Label>Text monogram (1–3 characters)</Label>
            <Input value={(data.monogram || {}).text || ''} onChange={v => update({ monogram: { ...(data.monogram || {}), text: v } })} placeholder="LL" />
            <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>Leave blank to use the default LL line drawing or the uploaded image below.</div>
          </div>
          <div>
            <Label>Custom mark (PNG/SVG — beats text)</Label>
            <ImageDrop value={(data.monogram || {}).src || ''} onChange={v => update({ monogram: { ...(data.monogram || {}), src: v } })} aspect="1/1" label="" />
            <div style={{ marginTop: 6 }}>
              <DBBtn label="Reset to default LL" small danger onClick={() => update({ monogram: { text: '', src: '' } })} />
            </div>
          </div>
        </div>
      </Card>

      <Card title="Contact">
        <Row><Label>Email</Label><Input value={c.email} onChange={v => setContact({ email: v })} type="email" /></Row>
        <Row><Label>Instagram</Label><Input value={c.instagram} onChange={v => setContact({ instagram: v })} /></Row>
        <Row><Label>Location</Label><Input value={c.location} onChange={v => setContact({ location: v })} /></Row>
      </Card>

      <Card title="🔒 Admin lock — hide the Dashboard from public visitors">
        <div style={{ fontSize: 12, color: '#666', lineHeight: 1.6, marginBottom: 12 }}>
          When set, the floating <strong>Dashboard</strong> button is <strong>hidden</strong> for visitors of your live site. To open the dashboard yourself: press <kbd style={{ background: '#0D0D0D', color: '#A5FF12', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', fontSize: 11 }}>Cmd / Ctrl + K</kbd> or visit <code style={{ background: '#F4F4F0', padding: '2px 6px', borderRadius: 4 }}>yourdomain.com/#admin</code> — you'll be prompted for the password. Leave empty for open access.
        </div>
        <Row>
          <Label>Admin password</Label>
          <Input value={(data.auth || {}).password || ''} onChange={v => update({ auth: { ...(data.auth || {}), password: v } })} placeholder="Leave empty for no password" type="text" />
        </Row>
        <div style={{ fontSize: 11, color: '#c00', background: '#fff0f4', border: '1px solid #fcc', padding: 10, borderRadius: 6, marginTop: 6 }}>
          ⚠️ This is a soft lock — it hides the UI from casual visitors but is NOT real server-side authentication. Anyone with browser developer tools can bypass it. For real security on your own domain, put the file behind a server login.
        </div>
      </Card>

      <Card title="About page · Headline">
        <Row><Label>Eyebrow</Label><Input value={a.eyebrow} onChange={v => setAbout({ eyebrow: v })} /></Row>
        <Row><Label>H1 (use line breaks)</Label><Textarea value={a.h1} onChange={v => setAbout({ h1: v })} rows={4} /></Row>
        <Row><Label>Intro paragraph</Label><Textarea value={a.intro} onChange={v => setAbout({ intro: v })} rows={3} /></Row>
        <Row><Label>Mission title (line breaks)</Label><Textarea value={a.missionTitle} onChange={v => setAbout({ missionTitle: v })} rows={3} /></Row>
        <Row><Label>Mission body</Label><Textarea value={a.missionBody} onChange={v => setAbout({ missionBody: v })} rows={3} /></Row>
      </Card>

      <Card title="About · Stats (the 4-up grid)">
        <ListEditor
          items={a.stats || []}
          onChange={v => setAbout({ stats: v })}
          blank={{ n: '', s: '', l: '' }}
          addLabel="+ Add stat"
          renderEditor={(st, i, set) => (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: 12 }}>
              <Row><Label>Number</Label><Input value={st.n} onChange={v => set({ n: v })} placeholder="50" /></Row>
              <Row><Label>Suffix (green)</Label><Input value={st.s} onChange={v => set({ s: v })} placeholder="+" /></Row>
              <Row><Label>Label</Label><Input value={st.l} onChange={v => set({ l: v })} placeholder="Brands Built" /></Row>
            </div>
          )} />
      </Card>

      <Card title="About · Values (the 3 cards)">
        <ListEditor
          items={a.values || []}
          onChange={v => setAbout({ values: v })}
          blank={{ icon: '🎯', title: '', desc: '' }}
          addLabel="+ Add value"
          renderEditor={(val, i, set) => (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: 12 }}>
                <Row><Label>Icon (emoji)</Label><Input value={val.icon} onChange={v => set({ icon: v })} /></Row>
                <Row>
                  <Label>Or pick from library</Label>
                  <Select value={val.iconName || ''} onChange={v => set({ iconName: v })} options={[
                    { value: '', label: '— use emoji above —' },
                    ...ICON_NAMES.map(n => ({ value: n, label: n })),
                  ]} />
                </Row>
                <Row><Label>Title</Label><Input value={val.title} onChange={v => set({ title: v })} /></Row>
              </div>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>
                If "library" is selected, that icon is used (and respects any custom SVG you uploaded in <strong>Icons</strong> tab). Otherwise the emoji is mapped to a default icon.
              </div>
              <Row><Label>Description</Label><Textarea value={val.desc} onChange={v => set({ desc: v })} rows={2} /></Row>
            </>
          )} />
      </Card>
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · THEME — Brand colors (drives CSS vars everywhere)
═══════════════════════════════════════════════════════════ */

function TabTheme({ data, update }) {
  const t = data.theme || {};
  const set = (k, v) => update({ theme: { ...t, [k]: v } });

  const SWATCHES = [
    { key: 'accent',     label: 'Brand Accent',     hint: 'The signature green — used for buttons, headlines, highlights everywhere.' },
    { key: 'accentText', label: 'Text on Accent',   hint: 'Text color drawn on top of accent-colored buttons / chips.' },
    { key: 'dark',       label: 'Dark Surface',     hint: 'Backgrounds for dark sections (hero, CTA strip, contact pane).' },
    { key: 'light',      label: 'Light Surface',    hint: 'Soft off-white for cards, dashboard backdrop.' },
    { key: 'text',       label: 'Body Text',        hint: 'Default body text on light backgrounds.' },
    { key: 'muted',      label: 'Muted Text',       hint: 'Secondary/supporting text.' },
    { key: 'border',     label: 'Borders',          hint: 'Subtle dividers between cards and rows.' },
  ];

  const PRESETS = [
    { name: 'Larinz Green',  accent: '#A5FF12', accentText: '#111111', dark: '#0D0D0D' },
    { name: 'Sunrise Coral', accent: '#FF6B4A', accentText: '#FFFFFF', dark: '#1A0F0D' },
    { name: 'Royal Indigo',  accent: '#6B5BFF', accentText: '#FFFFFF', dark: '#0B0820' },
    { name: 'Honey Gold',    accent: '#F5C842', accentText: '#111111', dark: '#1B1408' },
    { name: 'Sky Cyan',      accent: '#22D3EE', accentText: '#0B1015', dark: '#08161B' },
    { name: 'Hot Pink',      accent: '#FF3DA5', accentText: '#FFFFFF', dark: '#1A0814' },
    { name: 'Mono Slate',    accent: '#1F2937', accentText: '#FFFFFF', dark: '#0A0A0A' },
  ];

  return (
    <>
      <PageTitle title="Theme · Brand Colors" sub="Every accent on the site comes from these values. Change the accent and the whole site re-paints — buttons, headlines, chips, dashboard highlights, all of it." />

      <Card title="Live preview">
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <button style={{ background: t.accent, color: t.accentText, padding: '10px 22px', borderRadius: 999, fontWeight: 800, fontSize: 12, letterSpacing: 1.4, textTransform: 'uppercase', border: 'none', cursor: 'pointer' }}>PRIMARY BUTTON</button>
          <button style={{ background: t.dark, color: '#fff', padding: '10px 22px', borderRadius: 999, fontWeight: 800, fontSize: 12, letterSpacing: 1.4, textTransform: 'uppercase', border: 'none' }}>DARK BUTTON</button>
          <span style={{ background: t.accent + '22', color: t.text, border: `1px solid ${t.accent}`, padding: '4px 12px', borderRadius: 999, fontSize: 11, fontWeight: 700, letterSpacing: .5, textTransform: 'uppercase' }}>chip</span>
          <span style={{ fontSize: 32, fontWeight: 900, letterSpacing: -1.5, color: t.text }}>
            IMPACT<span style={{ color: t.accent }}>.</span>
          </span>
        </div>
      </Card>

      <Card title="Presets — one click to swap your whole vibe">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 10 }}>
          {PRESETS.map(p => (
            <div key={p.name} onClick={() => update({ theme: { ...t, accent: p.accent, accentText: p.accentText, dark: p.dark } })} style={{
              background: '#fff', border: '1.5px solid #EAEAE6', borderRadius: 10,
              padding: 10, cursor: 'pointer', transition: 'all .2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = p.accent; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#EAEAE6'; e.currentTarget.style.transform = 'none'; }}>
              <div style={{ display: 'flex', height: 28, borderRadius: 6, overflow: 'hidden', marginBottom: 8 }}>
                <div style={{ flex: 2, background: p.accent }} />
                <div style={{ flex: 1, background: p.dark }} />
                <div style={{ flex: 1, background: '#F4F4F0' }} />
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#111' }}>{p.name}</div>
              <div style={{ fontSize: 10, color: '#888', fontFamily: 'monospace', marginTop: 2 }}>{p.accent}</div>
            </div>
          ))}
        </div>
      </Card>

      <Card title="Brand palette — add as many colors as you want">
        <div style={{ fontSize: 12, color: '#666', marginBottom: 12, lineHeight: 1.6 }}>
          Add named colors to keep your full brand palette in one place — secondary brand colors, supporting tones, anything beyond the 7 system colors above. Click <strong>×</strong> on any swatch to remove.
        </div>
        <PaletteEditor value={t.palette || []} onChange={v => set('palette', v)} />
      </Card>

      <Card title="Custom colors">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {SWATCHES.map(s => (
            <div key={s.key} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: 10, border: '1px solid #EAEAE6', borderRadius: 8, background: '#FAFAF7' }}>
              <input type="color" value={t[s.key] || '#000000'} onChange={e => set(s.key, e.target.value)} style={{ width: 48, height: 48, border: 'none', padding: 0, background: 'transparent', cursor: 'pointer', flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#111' }}>{s.label}</div>
                <input value={t[s.key] || ''} onChange={e => set(s.key, e.target.value)} placeholder="#hex" style={{ width: '100%', border: 'none', background: 'transparent', fontFamily: 'monospace', fontSize: 12, color: '#555', outline: 'none', padding: '4px 0' }} />
                <div style={{ fontSize: 10, color: '#888', lineHeight: 1.4 }}>{s.hint}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14 }}>
          <DBBtn label="Reset to defaults" danger small onClick={() => {
            if (confirm('Reset colors to Larinz Green defaults?')) {
              update({ theme: JSON.parse(JSON.stringify(window.LL_DEFAULTS.theme)) });
            }
          }} />
        </div>
      </Card>
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · ICONS — Override any icon with a custom SVG upload
═══════════════════════════════════════════════════════════ */

const ICON_NAMES = ['camera','video','social','target','bolt','handshake','mail','instagram','pin','package','arrowRight','check','play'];

function TabIcons({ data, update }) {
  const overrides = data.iconOverrides || {};
  const setOverride = (name, svg) => update({ iconOverrides: { ...overrides, [name]: svg } });
  const removeOverride = (name) => {
    const next = { ...overrides };
    delete next[name];
    update({ iconOverrides: next });
  };

  return (
    <>
      <PageTitle title="Icons" sub="Replace any icon with a custom SVG file. Drop a .svg here and it'll be used everywhere that icon appears (services, contact, value cards, etc.). Leave empty to use the built-in design-system icon." />
      <Card title="Icon library">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
          {ICON_NAMES.map(name => (
            <IconSlot key={name} name={name} value={overrides[name]} onChange={svg => setOverride(name, svg)} onClear={() => removeOverride(name)} />
          ))}
        </div>
      </Card>
      <Card title="How to use">
        <ol style={{ paddingLeft: 18, fontSize: 13, lineHeight: 2, color: '#444', margin: 0 }}>
          <li>Drop or pick a <code style={{ background: '#F4F4F0', padding: '2px 6px', borderRadius: 4 }}>.svg</code> file on any icon above.</li>
          <li>For best results: clean outline SVG, <code style={{ background: '#F4F4F0', padding: '2px 6px', borderRadius: 4 }}>viewBox=&quot;0 0 24 24&quot;</code>, paths with <code style={{ background: '#F4F4F0', padding: '2px 6px', borderRadius: 4 }}>stroke=&quot;currentColor&quot;</code> so it inherits the brand color.</li>
          <li>Click <strong>×</strong> to remove the override and fall back to the default icon.</li>
          <li>To rename / change which icon a service uses — go to <strong>Services</strong> and pick an emoji that maps to the icon (📷→camera, 🎥→video, 📊→social, 🎯→target, ⚡→bolt, 🤝→handshake).</li>
        </ol>
      </Card>
    </>
  );
}

function IconSlot({ name, value, onChange, onClear }) {
  const ref = React.useRef();
  const [drag, setDrag] = React.useState(false);
  const handleFile = (file) => {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.svg') && file.type !== 'image/svg+xml') {
      alert('Please drop an SVG file.'); return;
    }
    const r = new FileReader();
    r.onload = () => onChange(r.result);
    r.readAsText(file);
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #EAEAE6', borderRadius: 10, padding: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 11, fontWeight: 800, color: '#111', letterSpacing: 1.5, textTransform: 'uppercase' }}>{name}</div>
        {value && <button onClick={onClear} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c00', fontSize: 14 }}>×</button>}
      </div>
      <div
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); handleFile(e.dataTransfer.files[0]); }}
        onClick={() => ref.current.click()}
        style={{
          aspectRatio: '1', border: `1.5px dashed ${drag ? '#A5FF12' : '#E0E0E0'}`,
          borderRadius: 8, background: drag ? '#FAFFF0' : (value ? '#FAFAF7' : '#FFF'),
          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 16, transition: 'all .2s', color: '#111',
        }}>
        {value
          ? <span style={{ width: 48, height: 48, display: 'inline-flex' }} dangerouslySetInnerHTML={{ __html: window.LL_sanitizeHTML ? window.LL_sanitizeHTML(value) : value }} />
          : React.createElement(window.Icon, { name, size: 32, color: '#111' })
        }
      </div>
      <input ref={ref} type="file" accept=".svg,image/svg+xml" style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files[0])} />
      <div style={{ fontSize: 10, color: '#888', textAlign: 'center', marginTop: 6 }}>
        {value ? 'Custom · drop to replace' : 'Drop SVG to override'}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   TAB · MESSAGES — Contact-form inbox (stored locally in the browser)
═══════════════════════════════════════════════════════════ */

const MSG_FILTERS = ['All', 'Unread', 'Read', 'Starred'];

function TabMessages() {
  const [list, setList]       = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError]     = React.useState(null);
  const [filter, setFilter]   = React.useState('All');
  const [query, setQuery]     = React.useState('');

  const getAuth = () => ({
    'Authorization': `Bearer ${window.LL_AUTH_TOKEN || ''}`,
    'Content-Type': 'application/json',
  });
  const apiBase = () => (window.LL_API && window.LL_API.API) || '/api';

  const load = React.useCallback(async () => {
    try {
      const r = await fetch(`${apiBase()}/contact`, { headers: getAuth() });
      if (!r.ok) throw new Error(`${r.status}`);
      setList(await r.json());
      setError(null);
    } catch (e) {
      setError('Could not load messages. Make sure you are signed in.');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => { load(); }, [load]);
  React.useEffect(() => {
    const id = setInterval(load, 30_000);
    return () => clearInterval(id);
  }, [load]);

  const patch = async (id, fields) => {
    await fetch(`${apiBase()}/contact/${id}`, {
      method: 'PATCH', headers: getAuth(), body: JSON.stringify(fields),
    });
    load();
  };
  const remove = async (id) => {
    if (!confirm('Delete this message? This cannot be undone.')) return;
    await fetch(`${apiBase()}/contact/${id}`, { method: 'DELETE', headers: getAuth() });
    load();
  };
  const markAllRead = async () => {
    await Promise.all(
      list.filter(m => !m.read).map(m =>
        fetch(`${apiBase()}/contact/${m.id}`, {
          method: 'PATCH', headers: getAuth(), body: JSON.stringify({ read: true }),
        })
      )
    );
    load();
  };

  const unread   = list.filter(m => !m.read).length;
  const starred  = list.filter(m => m.starred).length;
  const fmt = (iso) => { try { return new Date(iso).toLocaleString(); } catch (e) { return iso; } };

  const counts = { All: list.length, Unread: unread, Read: list.length - unread, Starred: starred };
  const q = query.trim().toLowerCase();
  const visible = list.filter(m => {
    if (filter === 'Unread'  && m.read)     return false;
    if (filter === 'Read'    && !m.read)    return false;
    if (filter === 'Starred' && !m.starred) return false;
    if (!q) return true;
    return (
      (m.name    || '').toLowerCase().includes(q) ||
      (m.email   || '').toLowerCase().includes(q) ||
      (m.message || '').toLowerCase().includes(q) ||
      (m.service || '').toLowerCase().includes(q)
    );
  });

  return (
    <>
      <PageTitle
        title="Messages"
        sub={`Contact form inbox · ${list.length} total · auto-refreshes every 30s`} />

      {/* Search */}
      <div style={{ position: 'relative', marginBottom: 12 }}>
        <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 14, color: '#aaa', pointerEvents: 'none' }}>🔍</span>
        <input
          type="text"
          placeholder="Search by name, email, service or message…"
          value={query}
          onChange={e => setQuery(e.target.value)}
          style={{
            width: '100%', boxSizing: 'border-box',
            padding: '9px 12px 9px 34px',
            fontSize: 13, fontFamily: 'Inter, sans-serif',
            border: '1.5px solid #E0E0DA', borderRadius: 8,
            background: '#FAFAF8', color: '#111',
            outline: 'none',
          }}
        />
        {query && (
          <button onClick={() => setQuery('')} style={{
            position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: '#aaa', lineHeight: 1,
          }}>✕</button>
        )}
      </div>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1.5px solid #EAEAE6', paddingBottom: 0 }}>
        {MSG_FILTERS.map(f => {
          const active = filter === f;
          return (
            <button key={f} onClick={() => setFilter(f)} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '8px 14px', fontSize: 12, fontWeight: 800,
              letterSpacing: 0.5, textTransform: 'uppercase', fontFamily: 'Inter, sans-serif',
              color: active ? '#111' : '#999',
              borderBottom: active ? '2.5px solid #A5FF12' : '2.5px solid transparent',
              marginBottom: -1.5,
              transition: 'color .15s',
            }}>
              {f}{counts[f] > 0 ? ` · ${counts[f]}` : ''}
            </button>
          );
        })}
        <div style={{ flex: 1 }} />
        {unread > 0 && (
          <button onClick={markAllRead} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: '8px 12px', fontSize: 11, fontWeight: 700,
            color: '#888', fontFamily: 'Inter, sans-serif', textTransform: 'uppercase', letterSpacing: 0.5,
          }}>Mark all read</button>
        )}
      </div>

      {error && <Card title="Error"><div style={{ fontSize: 13, color: '#c00' }}>{error}</div></Card>}
      {!error && loading && <div style={{ fontSize: 13, color: '#888', padding: 16 }}>Loading…</div>}

      {!error && !loading && visible.length === 0 && (
        <Card title={filter === 'All' ? 'Inbox empty' : `No ${filter.toLowerCase()} messages`}>
          <div style={{ fontSize: 13, color: '#888', lineHeight: 1.7 }}>
            {filter === 'All'
              ? <>No messages yet. When a visitor fills in the <strong>Contact → Start a Project</strong> form, it shows up here.</>
              : `Switch to "All" to see everything.`}
          </div>
        </Card>
      )}

      {!error && !loading && visible.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {visible.map(m => (
            <div key={m.id} style={{
              background: m.read ? '#fff' : '#FAFFF0',
              border: `1.5px solid ${m.starred ? '#FFD600' : m.read ? '#EAEAE6' : '#A5FF12'}`,
              borderRadius: 10, padding: 16,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 8 }}>
                <div style={{ minWidth: 0, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                  {/* Star toggle */}
                  <button onClick={() => patch(m.id, { starred: !m.starred })} title={m.starred ? 'Unstar' : 'Star'} style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: 16, lineHeight: 1, padding: '2px 0', flexShrink: 0,
                    color: m.starred ? '#FFD600' : '#ccc',
                  }}>★</button>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: '#111', display: 'flex', alignItems: 'center', gap: 8 }}>
                      {!m.read && <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#A5FF12', flexShrink: 0 }} />}
                      {m.name || 'Anonymous'}
                    </div>
                    <a href={`mailto:${m.email}`} style={{ fontSize: 12, color: '#2A6FDB', textDecoration: 'none' }}>{m.email}</a>
                    {m.service && <span style={{ marginLeft: 10, fontSize: 11, background: '#F4F4F0', color: '#666', padding: '2px 8px', borderRadius: 999, fontWeight: 700 }}>{m.service}</span>}
                  </div>
                </div>
                <div style={{ fontSize: 11, color: '#aaa', whiteSpace: 'nowrap', flexShrink: 0 }}>{fmt(m.created_at)}</div>
              </div>
              {m.message && <div style={{ fontSize: 13, color: '#444', lineHeight: 1.6, whiteSpace: 'pre-wrap', marginBottom: 12, paddingLeft: 26 }}>{m.message}</div>}
              <div style={{ display: 'flex', gap: 6, paddingLeft: 26 }}>
                <DBBtn label={m.read ? 'Mark unread' : 'Mark read'} small onLight onClick={() => patch(m.id, { read: !m.read })} />
                <a href={`mailto:${m.email}?subject=Re: your message to Larinz Labz`} style={{ textDecoration: 'none' }}>
                  <DBBtn label="Reply ↗" small onLight />
                </a>
                <DBBtn label="Delete" small danger onClick={() => remove(m.id)} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

/* ════════════════════════════════════════════════════════════
   FLOATING TOGGLE BUTTON
═══════════════════════════════════════════════════════════ */

function DashboardFAB({ onOpen, hidden }) {
  if (hidden) return null;
  return (
    <button onClick={onOpen} style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 7000,
      background: '#111', color: '#fff', border: 'none',
      borderRadius: 999, padding: '12px 22px',
      fontSize: 12, fontWeight: 800, letterSpacing: 1,
      textTransform: 'uppercase', cursor: 'pointer',
      boxShadow: '0 8px 28px rgba(0,0,0,.25)',
      fontFamily: 'Inter, sans-serif',
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--ll-accent, #A5FF12)', display: 'inline-block' }} />
      Dashboard
    </button>
  );
}

Object.assign(window, { Dashboard, DashboardFAB });


/* Expose dashboard sub-components on window for cross-script references. */
if (typeof window !== 'undefined') {
  Object.assign(window, {
    Dashboard, DashHeader, DashSidebar, DBBtn, Card, Row, Label,
    Input, Textarea, Select, ImageDrop, ListEditor,
    TabOverview, PageTitle, TabHero, ChipList, TabServices, TabProjects,
    Section, DeptSection, HeroMediaEditor, ReelsEditor, StatsEditor,
    PaletteEditor, GalleryEditor, TabStudio, TabReels, TabBrands,
    TabSections, SectionItemsEditor, TabSettings, TabTheme, TabIcons,
    IconSlot, TabMessages, DashboardFAB,
  });
}

export { Dashboard };
